import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** An ISO 8601-encoded date */
  ISO8601Date: any;
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: any;
};

export type AbsoluteTime = {
  __typename?: 'AbsoluteTime';
  /** Datetime. */
  datetime: Scalars['ISO8601DateTime'];
};

/** Autogenerated input type of AcknowledgeConsumerOrder */
export type AcknowledgeConsumerOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Consumer order ID. */
  consumerOrderId: Scalars['ID'];
  /**
   * Order's current lock version. If an outdated lock version is provided, the
   * operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int'];
};

/** Autogenerated return type of AcknowledgeConsumerOrder */
export type AcknowledgeConsumerOrderPayload = {
  __typename?: 'AcknowledgeConsumerOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to acknowledge the order. */
  result: ConsumerOrderResult;
};

/** Input for adding an item to the cart. */
export type AddCartItemInput = {
  /** MenuItem ID */
  menuItemId: Scalars['ID'];
  /** MenuItemSize ID */
  menuItemSizeId: Scalars['ID'];
  /** List of cart item modifiers. */
  modifiers: Array<CartItemModifierInput>;
  /** Note. */
  note?: InputMaybe<Scalars['String']>;
  /** Quantity */
  quantity: Scalars['Int'];
  /** Expected unit price of MenuItemSize. Item will only be added if its current price matches the expected price. */
  unitPrice: MoneyInput;
};

/** Data that was provided as mutation input. */
export type AddCartItemInputEcho = {
  __typename?: 'AddCartItemInputEcho';
  /** MenuItem ID */
  menuItemId: Scalars['ID'];
  /** MenuItemSize ID */
  menuItemSizeId: Scalars['ID'];
  /** List of cart item modifiers. */
  modifiers: Array<CartItemModifierInputEcho>;
  /** Quantity */
  quantity: Scalars['Int'];
  /** Expected unit price of MenuItemSize. Item will only be added if its current price matches the expected price. */
  unitPrice: Money;
};

/** Autogenerated input type of AddFavoriteConsumerOrder */
export type AddFavoriteConsumerOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Consumer order ID. */
  consumerOrderId: Scalars['ID'];
  /** Icon. */
  icon?: InputMaybe<Scalars['String']>;
  /** Name. */
  name?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of AddFavoriteConsumerOrder */
export type AddFavoriteConsumerOrderPayload = {
  __typename?: 'AddFavoriteConsumerOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to add the favorite. */
  result: FavoriteConsumerOrderResult;
};

/** Autogenerated input type of AddItemsToCart */
export type AddItemsToCartInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Opaque token identifying a specific version of the cart. */
  fingerprint: Scalars['String'];
  /** List of items to add to the cart. */
  items: Array<AddCartItemInput>;
};

/** Autogenerated return type of AddItemsToCart */
export type AddItemsToCartPayload = {
  __typename?: 'AddItemsToCartPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to add items to the cart. */
  result: CartResult;
};

export type Address = {
  __typename?: 'Address';
  addressLine1: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  countryCode: Scalars['String'];
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  postalCode: Scalars['String'];
  state: Scalars['String'];
};

export type AllowanceRecipient = Node & {
  __typename?: 'AllowanceRecipient';
  /** Email. */
  email: Scalars['String'];
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID'];
};

/** The connection type for AllowanceRecipient. */
export type AllowanceRecipientConnection = {
  __typename?: 'AllowanceRecipientConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AllowanceRecipientEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<AllowanceRecipient>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type AllowanceRecipientEdge = {
  __typename?: 'AllowanceRecipientEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<AllowanceRecipient>;
};

/** AllowanceRecipient sort criteria */
export type AllowanceRecipientOrderBy = {
  /** Email. */
  email?: InputMaybe<OrderByEnum>;
};

/**
 * Error indicating that an UpdateCartItems mutation failed due to ambiguity
 * introduced by the provided inputs. This can occur if two or more inputs are
 * given for the same cart item, or if an inputs lists the same modifier more than
 * once. Note that we take an all-or-nothing approach when updating cart items, so
 * any ambiguity will abort the entire operation.
 */
export type AmbiguousCartItemUpdates = Error & {
  __typename?: 'AmbiguousCartItemUpdates';
  /** First UpdateCartItemInput involved in the ambiguity. */
  head: UpdateCartItemInputEcho;
  /** A description of the error. */
  message: Scalars['String'];
  /** List (possibly empty) of additional UpdateCartItemInput objects involved in the ambiguity. */
  tail: Array<UpdateCartItemInputEcho>;
};

/** Autogenerated input type of ApplyReward */
export type ApplyRewardInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Opaque token identifying a specific version of the cart. */
  fingerprint: Scalars['String'];
  /** Reward ID. */
  rewardId: Scalars['ID'];
};

/** Autogenerated return type of ApplyReward */
export type ApplyRewardPayload = {
  __typename?: 'ApplyRewardPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to apply reward. */
  result: CartResult;
};

export type Attachment = {
  __typename?: 'Attachment';
  id: Scalars['ID'];
  objectKey: Scalars['String'];
  url: Scalars['String'];
};

/** Autogenerated input type of AttachmentUrlPresignerCreate */
export type AttachmentUrlPresignerCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of AttachmentUrlPresignerCreate */
export type AttachmentUrlPresignerCreatePayload = {
  __typename?: 'AttachmentUrlPresignerCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  objectKey?: Maybe<Scalars['String']>;
  presignedReadUrl?: Maybe<Scalars['String']>;
  presignedUrl?: Maybe<Scalars['String']>;
  userErrors: Array<PresignerError>;
};

export type AvailabilityInterval = {
  /** Lower bound. */
  lowerBound: Scalars['ISO8601DateTime'];
  /** Upper bound. */
  upperBound: Scalars['ISO8601DateTime'];
};

export type AvailableInterval = AvailabilityInterval & {
  __typename?: 'AvailableInterval';
  /** Lower bound. */
  lowerBound: Scalars['ISO8601DateTime'];
  /** Upper bound. */
  upperBound: Scalars['ISO8601DateTime'];
};

/**
 * Error indicating that a mutation failed due to a bad payment processor request.
 * This occurs when expired, unsupported, or otherwise invalid payment details are
 * provided. The request should not be retried until the problem is corrected.
 */
export type BadPaymentProcessorRequestError = Error & {
  __typename?: 'BadPaymentProcessorRequestError';
  /** A code characterizing the type of error. */
  code: Scalars['String'];
  /** A description of the error. */
  message: Scalars['String'];
};

export type BaseServiceTask = ServiceTask & {
  __typename?: 'BaseServiceTask';
  fulfilledAt?: Maybe<Scalars['ISO8601DateTime']>;
  fulfillmentIssues: Array<FulfillmentIssue>;
  id: Scalars['ID'];
  serviceTaskMessage?: Maybe<ServiceTaskMessage>;
  taskType: Task;
};

export type BatchedDeposit = Node & {
  __typename?: 'BatchedDeposit';
  /** Gross earnings for the period, in cents */
  earnedSubtotalCents?: Maybe<Scalars['Int']>;
  /** Currency code of gross earnings */
  earnedSubtotalCurrency: Scalars['String'];
  /** Memo describing the deposit */
  externalMemo?: Maybe<Scalars['String']>;
  /** End of the period deposits were batched for */
  for: Scalars['ISO8601Date'];
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID'];
  /** Transaction id last fetched from the payment processor */
  lastKnownTransactionId?: Maybe<Scalars['String']>;
  /** Transaction status last fetched from the payment processor */
  lastKnownTransactionStatus?: Maybe<Scalars['String']>;
  /** Merchant deposits were batched for */
  merchant: Merchant;
  /** Amount deducted to pay down merchant's outstanding balance, in cents */
  outstandingCents?: Maybe<Scalars['Int']>;
  /** Currency code of amount deducted */
  outstandingCurrency: Scalars['String'];
  /** Type of period deposits were batched for */
  period: BatchedDepositPeriodEnum;
  /** When the deposit was submitted to the payment processor */
  submittedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Net amount deposited in merchant's account, in cents */
  totalCents?: Maybe<Scalars['Int']>;
  /** Currency code of net amount */
  totalCurrency: Scalars['String'];
};

/** The connection type for BatchedDeposit. */
export type BatchedDepositConnection = {
  __typename?: 'BatchedDepositConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<BatchedDepositEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<BatchedDeposit>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type BatchedDepositEdge = {
  __typename?: 'BatchedDepositEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<BatchedDeposit>;
};

/** BatchedDeposit sort criteria */
export type BatchedDepositOrderBy = {
  /** End of the period deposits were batched for */
  for?: InputMaybe<OrderByEnum>;
};

/** BatchedDeposit period values */
export enum BatchedDepositPeriodEnum {
  /** Deposits batched daily */
  Daily = 'daily',
  /** Single, non-recurring batch */
  OneOff = 'one_off',
  /** Deposits batched weekly */
  Weekly = 'weekly'
}

export type Business = Node & {
  __typename?: 'Business';
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID'];
};

/** User or Business level error to indicate that something went wrong. */
export type BusinessError = {
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

/** Input of a Business Search */
export type BusinessSearchInput = {
  /** Globally unique ID */
  id: Scalars['ID'];
};

export enum CafeAction {
  /** Actions requiring dropping things off at coffee shops */
  DropOff = 'drop_off',
  /** Actions requiring taking things away from the coffee shop */
  PickUp = 'pick_up'
}

/** Shopping cart */
export type Cart = {
  __typename?: 'Cart';
  /** Consumer app user service fee. */
  appUserServiceFee: Money;
  /** Items in the cart. */
  cartItems: Array<CartItem>;
  /** Delivery fee. */
  deliveryFee: Money;
  /** Opaque token identifying a specific version of the cart. */
  fingerprint: Scalars['String'];
  /**
   * Merchant. When the cart is empty, this field is null. When the cart contains
   * one or more items, this field reflects the merchant who sells those items.
   * Note that the cart cannot contain items from multiple merchants.
   */
  merchant?: Maybe<Merchant>;
  /** Pickup schedule. Null if cart is empty. */
  pickupSchedule?: Maybe<PickupSchedule>;
  /** Reward. */
  reward?: Maybe<Reward>;
  /** Reward value. */
  rewardValue: Money;
  /** Subtotal. */
  subtotal: Money;
  /** Tax. */
  tax: Money;
  /** Tip. */
  tip: Money;
  /** Total. */
  total: Money;
};


/** Shopping cart */
export type CartPickupScheduleArgs = {
  asOf?: InputMaybe<Scalars['ISO8601DateTime']>;
};

/** Result of a Cart mutation that failed due to a concurrently running checkout request. */
export type CartCheckoutInFlightError = Error & {
  __typename?: 'CartCheckoutInFlightError';
  /** A description of the error. */
  message: Scalars['String'];
};

/** Item in shopping cart. */
export type CartItem = Node & {
  __typename?: 'CartItem';
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID'];
  /** Menu item. Null if the merchant has removed the item from their menu. */
  menuItem?: Maybe<MenuItem>;
  /** Menu item size. Null if the merchant removed the size from their menu. */
  menuItemSize?: Maybe<MenuItemSize>;
  /** Cart item modifiers. */
  modifiers: Array<CartItemModifier>;
  /** Note. */
  note?: Maybe<Scalars['String']>;
  /** Quantity. */
  quantity: Scalars['Int'];
  /** Unit price for menu item size (not including modifiers). */
  unitPrice: Money;
};

/** Cart item modifier. */
export type CartItemModifier = Node & {
  __typename?: 'CartItemModifier';
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID'];
  /** Menu item modifier group. Null if the merchant has removed the group from their menu. */
  menuItemModifierGroup?: Maybe<MenuItemModifierGroup>;
  /** Menu item modifier option. Null if the merchant has removed the option from their menu. */
  menuItemModifierOption?: Maybe<MenuItemModifierOption>;
  /** Quantity. */
  quantity: Scalars['Int'];
  /** Unit price for menu item modifier option. */
  unitPrice: Money;
};

/**
 * Error indicating that a mutation failed because an item in the cart references a
 * modifier group that could not be found on the menu. This can occur if the menu
 * has changed since the item was added to the cart.
 */
export type CartItemModifierGroupNotFound = Error & {
  __typename?: 'CartItemModifierGroupNotFound';
  /** ID of the menu item modifier group that could not be found. */
  menuItemModifierGroupId: Scalars['ID'];
  /** A description of the error. */
  message: Scalars['String'];
};

/** Input for a cart item modifier. */
export type CartItemModifierInput = {
  /** MenuItemModifierGroup ID */
  menuItemModifierGroupId: Scalars['ID'];
  /** MenuItemModifierOption ID */
  menuItemModifierOptionId: Scalars['ID'];
  /** Quantity */
  quantity: Scalars['Int'];
  /** Expected unit price of modifier. Modifier will only be added if its current price matches the expected price. */
  unitPrice: MoneyInput;
};

/** Data that was provided as mutation input. */
export type CartItemModifierInputEcho = {
  __typename?: 'CartItemModifierInputEcho';
  /** MenuItemModifierGroup ID */
  menuItemModifierGroupId: Scalars['ID'];
  /** MenuItemModifierOption ID */
  menuItemModifierOptionId: Scalars['ID'];
  /** Quantity */
  quantity: Scalars['Int'];
  /** Expected unit price of modifier. Modifier will only be added if its current price matches the expected price. */
  unitPrice: Money;
};

/**
 * Error indicating that a mutation failed because an item in the cart references a
 * modifier option that could not be found on the menu. This can occur if the menu
 * has changed since the item was added to the cart.
 */
export type CartItemModifierOptionNotFound = Error & {
  __typename?: 'CartItemModifierOptionNotFound';
  /** ID of the menu item modifier option that could not be found. */
  menuItemModifierOptionId: Scalars['ID'];
  /** A description of the error. */
  message: Scalars['String'];
};

/** Error indicating that a Cart mutation failed to add an item. */
export type CartItemNotAdded = Error & {
  __typename?: 'CartItemNotAdded';
  /**
   * AddCartItemInput data that caused the error. Note that we take an
   * all-or-nothing approach when adding items to the cart, so one failed item
   * aborts the entire operation.
   */
  input: AddCartItemInputEcho;
  /** A description of the error. */
  message: Scalars['String'];
};

/** Error indicating that a mutation failed because an item is not available at the requested pickup time. */
export type CartItemNotAvailable = Error & {
  __typename?: 'CartItemNotAvailable';
  /** Menu item. */
  menuItem: MenuItem;
  /** A description of the error. */
  message: Scalars['String'];
};

/** Error indicating that a Cart mutation failed to update an item. */
export type CartItemNotUpdated = Error & {
  __typename?: 'CartItemNotUpdated';
  /**
   * UpdateCartItemInput data that caused the error. Note that we take an
   * all-or-nothing approach to updating items in the cart, so one failed item
   * aborts the entire operation.
   */
  input: UpdateCartItemInputEcho;
  /** A description of the error. */
  message: Scalars['String'];
};

/**
 * Error indicating that a mutation failed because an item in the cart references a
 * size that could not be found on the menu. This can occur if the menu has changed
 * since the item was added to the cart.
 */
export type CartItemSizeNotFound = Error & {
  __typename?: 'CartItemSizeNotFound';
  /** ID of the menu item size that could not be found. */
  menuItemSizeId: Scalars['ID'];
  /** A description of the error. */
  message: Scalars['String'];
};

/**
 * Error indicating that a mutation failed because an item in the cart could not be
 * found on the menu. This can occur if the menu has changed since the item was
 * added to the cart.
 */
export type CartMenuItemNotFound = Error & {
  __typename?: 'CartMenuItemNotFound';
  /** ID of the menu item that could not be found. */
  menuItemId: Scalars['ID'];
  /** A description of the error. */
  message: Scalars['String'];
};

/** Result of a Cart mutation that failed due to items from multiple merchants. */
export type CartMerchantMismatchError = Error & {
  __typename?: 'CartMerchantMismatchError';
  /** Relevant menu item IDs grouped by merchant. */
  byMerchant: Array<MenuItemsForMerchant>;
  /** A description of the error. */
  message: Scalars['String'];
};

/** Error indicating that a Cart mutation failed to save the cart. */
export type CartNotSaved = Error & {
  __typename?: 'CartNotSaved';
  /** A description of the error. */
  message: Scalars['String'];
};

/** Result of a Cart mutation that failed because no available pickup times could be found. */
export type CartPickupUnavailableError = Error & {
  __typename?: 'CartPickupUnavailableError';
  /** A description of the error. */
  message: Scalars['String'];
  /** Pickup schedule. */
  pickupSchedule: PickupSchedule;
};

/** Cart mutation result. */
export type CartResult = CartSuccess | ErrorsResult;

/** Result of a successful Cart mutation. */
export type CartSuccess = {
  __typename?: 'CartSuccess';
  /** Resulting cart. */
  cart: Cart;
};

export enum CatalogStatus {
  InCatalog = 'IN_CATALOG',
  NotInCatalog = 'NOT_IN_CATALOG'
}

export enum CategoriesFilter {
  TopLevel = 'TOP_LEVEL'
}

export enum CategoriesSortOrder {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  PositionAsc = 'POSITION_ASC',
  PositionDesc = 'POSITION_DESC'
}

export type Category = {
  __typename?: 'Category';
  createdAt: Scalars['ISO8601DateTime'];
  createdBy: Scalars['String'];
  id: Scalars['ID'];
  items: ItemConnection;
  name: Scalars['String'];
  parentCategory?: Maybe<Category>;
  position?: Maybe<Scalars['Int']>;
  subcategories: Array<Category>;
  updatedAt: Scalars['ISO8601DateTime'];
  updatedBy: Scalars['String'];
};


export type CategoryItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  itemTypes?: InputMaybe<Array<InputMaybe<ItemType>>>;
  last?: InputMaybe<Scalars['Int']>;
  searchQuery?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Array<InputMaybe<ItemsSortOrder>>>;
  vendors?: InputMaybe<Array<InputMaybe<ItemsVendorInput>>>;
  warehouses?: InputMaybe<Array<InputMaybe<ItemsWarehouseInput>>>;
};


export type CategorySubcategoriesArgs = {
  sortOrder?: InputMaybe<Array<InputMaybe<CategoriesSortOrder>>>;
};

/** Autogenerated input type of Checkout */
export type CheckoutInput = {
  /**
   * Desired pickup time, expressed in absolute terms. Checkout will only proceed
   * if this is available pickup time according to the merchant's schedule and
   * respect's the merchant's minimum notice setting. Either this argument or the
   * relativePickupTime argument must be specified, but not both.
   */
  absolutePickupTime?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Curbside color. */
  curbsideColor?: InputMaybe<Scalars['String']>;
  /** Curbside make. */
  curbsideMake?: InputMaybe<Scalars['String']>;
  /** Curbside model. */
  curbsideModel?: InputMaybe<Scalars['String']>;
  /** Whether order is for curbside pickup. */
  curbsidePickup?: InputMaybe<Scalars['Boolean']>;
  /** Delivery detail. */
  deliveryDetail?: InputMaybe<DeliveryDetailInput>;
  /** Email address to send receipt to. */
  email?: InputMaybe<Scalars['String']>;
  /** Opaque token identifying a specific version of the cart. */
  fingerprint: Scalars['String'];
  /** Customer name to attach to the order. */
  name: Scalars['String'];
  /**
   * Payment method. Checkout will only proceed if cart's calculated prices using
   * this payment method match the prices of the cart version identified by fingerprint.
   */
  paymentMethod: PaymentMethod;
  /** Client app platform. */
  platform: ClientAppPlatform;
  /**
   * Desired pickup time, expressed relative to the current time. Checkout will
   * only proceed if this is available pickup time according to the merchant's
   * schedule and respect's the merchant's minimum notice setting. Either this
   * argument or the absolutePickupTime argument must be specified, but not both.
   */
  relativePickupTime?: InputMaybe<RelativeTimeInput>;
  /** Square card id. Required if using the "square_card_id" payment method. */
  squareCardId?: InputMaybe<Scalars['String']>;
  /** Square card nonce. Required if using the "square_card_nonce" payment method. */
  squareCardNonce?: InputMaybe<Scalars['String']>;
  /** Whether order is "to go" (i.e. takeout/takeaway). */
  toGo: Scalars['Boolean'];
};

/** Autogenerated return type of Checkout */
export type CheckoutPayload = {
  __typename?: 'CheckoutPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to process checkout. */
  result: CheckoutResult;
};

/** Checkout mutation result. */
export type CheckoutResult = CheckoutSuccess | ErrorsResult;

/** Result of a successful checkout mutation. */
export type CheckoutSuccess = {
  __typename?: 'CheckoutSuccess';
  /** Fresh cart info. */
  cart: Cart;
  /** Earned reward, applicable to a future order. */
  earnedReward?: Maybe<Reward>;
  /** Resulting consumer order. */
  order: ConsumerOrder;
};

/** Autogenerated input type of ClaimReward */
export type ClaimRewardInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Reward code. */
  code: Scalars['String'];
};

/** Autogenerated return type of ClaimReward */
export type ClaimRewardPayload = {
  __typename?: 'ClaimRewardPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to claim reward. */
  result: RewardResult;
};

/** Client app platform values. */
export enum ClientAppPlatform {
  /** Android. */
  Android = 'android',
  /** Apple (iOS). */
  Apple = 'apple',
  /** Web. */
  Web = 'web'
}

/** Configuration info */
export type Config = Node & {
  __typename?: 'Config';
  /** Oldest supported consumer Android app */
  consumerAndroidForceVersion: Scalars['String'];
  /** Latest consumer Android app */
  consumerAndroidLatestVersion: Scalars['String'];
  /** Oldest supported consumer iOS app */
  consumerIosForceVersion: Scalars['String'];
  /** Latest consumer iOS app */
  consumerIosLatestVersion: Scalars['String'];
  /** When this edition of the config was added to the database */
  createdAt: Scalars['ISO8601DateTime'];
  /** Position in chronological sequence of configs */
  edition: Scalars['Int'];
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID'];
  /** Oldest supported merchant Amazon app */
  merchantAmazonForceVersion: Scalars['String'];
  /** Latest merchant Amazon app */
  merchantAmazonLatestVersion: Scalars['String'];
  /** Oldest supported merchant Android app */
  merchantAndroidForceVersion: Scalars['String'];
  /** Latest merchant Android app */
  merchantAndroidLatestVersion: Scalars['String'];
  /** Oldest supported merchant iOS app */
  merchantIosForceVersion: Scalars['String'];
  /** Latest merchant iOS app */
  merchantIosLatestVersion: Scalars['String'];
  /** Upgrade message shown to merchants with an Odeko-provided tablet */
  merchantTabletUpgradeMessage?: Maybe<Scalars['String']>;
  /** Date when tablet upgrade message starts appearing */
  merchantTabletUpgradeStartDate?: Maybe<Scalars['ISO8601Date']>;
  /** @deprecated Each edition of the config is immutable, so an update generates a new edition */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Attributes for creating a config */
export type ConfigAttributes = {
  /** Oldest supported consumer Android app */
  consumerAndroidForceVersion: Scalars['String'];
  /** Latest consumer Android app */
  consumerAndroidLatestVersion: Scalars['String'];
  /** Oldest supported consumer iOS app */
  consumerIosForceVersion: Scalars['String'];
  /** Latest consumer iOS app */
  consumerIosLatestVersion: Scalars['String'];
  /** Oldest supported merchant Amazon app */
  merchantAmazonForceVersion: Scalars['String'];
  /** Latest merchant Amazon app */
  merchantAmazonLatestVersion: Scalars['String'];
  /** Oldest supported merchant Android app */
  merchantAndroidForceVersion: Scalars['String'];
  /** Latest merchant Android app */
  merchantAndroidLatestVersion: Scalars['String'];
  /** Oldest supported merchant iOS app */
  merchantIosForceVersion: Scalars['String'];
  /** Latest merchant iOS app */
  merchantIosLatestVersion: Scalars['String'];
  /** Upgrade message shown to merchants with an Odeko-provided tablet */
  merchantTabletUpgradeMessage?: InputMaybe<Scalars['String']>;
  /** Date when tablet upgrade message starts appearing */
  merchantTabletUpgradeStartDate?: InputMaybe<Scalars['String']>;
};

/** The connection type for Config. */
export type ConfigConnection = {
  __typename?: 'ConfigConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ConfigEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Config>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ConfigEdge = {
  __typename?: 'ConfigEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Config>;
};

/** Config sort criteria */
export type ConfigOrderBy = {
  /** Position in chronological sequence of configs */
  edition?: InputMaybe<OrderByEnum>;
};

/** Config mutation result */
export type ConfigResult = ConfigSuccess | InvalidConfigError | StaleConfigError;

/** Result of a successful Config mutation */
export type ConfigSuccess = {
  __typename?: 'ConfigSuccess';
  /** Resulting config */
  config: Config;
};

/** Consumer app user. */
export type ConsumerAppUser = Node & {
  __typename?: 'ConsumerAppUser';
  /** Accepts promotional emails. */
  acceptsPromotionalEmails: Scalars['Boolean'];
  /** The primary key from the database. */
  databaseId: Scalars['Int'];
  /** Email. */
  email?: Maybe<Scalars['String']>;
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID'];
  /** Whether this is a guest account. */
  isGuestAccount: Scalars['Boolean'];
  /** Merchant can contact. */
  merchantCanContact?: Maybe<Scalars['Boolean']>;
  /** Phone number. */
  phoneNumber?: Maybe<Scalars['String']>;
  /** Total discount received on orders so far. */
  totalMoneySaved: Money;
  /** Username. */
  username?: Maybe<Scalars['String']>;
};

/** Consumer app user Firebase login result. */
export type ConsumerAppUserFirebaseLoginResult = ConsumerAppUserFirebaseLoginSuccess | ErrorsResult;

/** Result of a successful consumer app user login from Firebase. */
export type ConsumerAppUserFirebaseLoginSuccess = {
  __typename?: 'ConsumerAppUserFirebaseLoginSuccess';
  /** Logged in consumer app user. */
  consumerAppUser: ConsumerAppUser;
  /** Session info. */
  session: JwtSession;
};

/** Error indicating invalid consumer app user attributes. */
export type ConsumerAppUserInvalid = Error & {
  __typename?: 'ConsumerAppUserInvalid';
  /** A description of the error. */
  message: Scalars['String'];
};

/** Error indicating that a consumer app user mutation failed to save the consumer app user. */
export type ConsumerAppUserNotSaved = Error & {
  __typename?: 'ConsumerAppUserNotSaved';
  /** A description of the error. */
  message: Scalars['String'];
};

/** Consumer app user mutation result. */
export type ConsumerAppUserResult = ConsumerAppUserSuccess | ErrorsResult;

/** Result of a successful consumer app user mutation. */
export type ConsumerAppUserSuccess = {
  __typename?: 'ConsumerAppUserSuccess';
  /** Resulting consumer app user. */
  consumerAppUser: ConsumerAppUser;
};

/** Consumer order. */
export type ConsumerOrder = Node & {
  __typename?: 'ConsumerOrder';
  /** When the order was marked complete. */
  completedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Service fee paid by customer. */
  consumerAppUserServiceFee: Money;
  /** Created at datetime. */
  createdAt: Scalars['ISO8601DateTime'];
  /** Curbside arrived. */
  curbsideArrived: Scalars['Boolean'];
  /** When customer reported curbside arrival. */
  curbsideArrivedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Curbside color. */
  curbsideColor?: Maybe<Scalars['String']>;
  /** Curbside make. */
  curbsideMake?: Maybe<Scalars['String']>;
  /** Curbside model. */
  curbsideModel?: Maybe<Scalars['String']>;
  /** Curbside pickup. */
  curbsidePickup: Scalars['Boolean'];
  /** Customer name. */
  customerName?: Maybe<Scalars['String']>;
  /** Customer phone number. Null if unset or if the customer has opted not to allow merchants to contact them. */
  customerPhone?: Maybe<Scalars['String']>;
  /** The primary key from the database. */
  databaseId: Scalars['Int'];
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID'];
  /** Line-items. */
  lineItems: Array<ConsumerOrderLineItem>;
  /** Order's current lock version, providing concurrency control and protection against stale updates. */
  lockVersion: Scalars['Int'];
  /** Merchant. */
  merchant: Merchant;
  /** When merchant acknowledged the order. */
  merchantAcknowledgedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** When the order was marked picked-up. */
  pickedUpAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Scheduled pickup datetime. */
  pickupTime: Scalars['ISO8601DateTime'];
  /** When the order was marked ready. */
  readiedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Refund info. */
  refundInfo: ConsumerRefundInfo;
  /** Discount applied by reward. */
  rewardValue: Money;
  /** Subtotal. */
  subtotal: Money;
  /** Tax. Based on subtotal - rewardValue. */
  tax: Money;
  /** Tip. */
  tip: Money;
  /** Total (subtotal - rewardValue + tax + tip + consumerAppUserServiceFee + deliveryFee). */
  total: Money;
};

/**
 * Result of attempting to create a full refund for a consumer order that
 * has already been refunded, either partially or fully. If the order has
 * only been partially refunded, clients desiring to refund the remaining
 * refundable amount should call createPartialConsumerRefund rather than
 * createFullConsumerRefund.
 */
export type ConsumerOrderAlreadyRefunded = Error & {
  __typename?: 'ConsumerOrderAlreadyRefunded';
  /** A description of the error. */
  message: Scalars['String'];
};

/** Autogenerated input type of ConsumerOrderComplete */
export type ConsumerOrderCompleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Consumer order ID. */
  consumerOrderId: Scalars['ID'];
  /**
   * Order's current lock version. If an outdated lock version is provided, the
   * operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int'];
};

/** Autogenerated return type of ConsumerOrderComplete */
export type ConsumerOrderCompletePayload = {
  __typename?: 'ConsumerOrderCompletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to mark the order complete. */
  result: ConsumerOrderResult;
};

/** The connection type for ConsumerOrder. */
export type ConsumerOrderConnection = {
  __typename?: 'ConsumerOrderConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ConsumerOrderEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ConsumerOrder>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ConsumerOrderEdge = {
  __typename?: 'ConsumerOrderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ConsumerOrder>;
};

/** Consumer order line-item. */
export type ConsumerOrderLineItem = Node & {
  __typename?: 'ConsumerOrderLineItem';
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID'];
  /** Item name. */
  itemName: Scalars['String'];
  /** Item quantity. */
  itemQuantity: Scalars['Int'];
  /** Item size. */
  itemSize: Scalars['String'];
  /** Modifiers. */
  modifiers: Array<ConsumerOrderLineItemModifier>;
  /** Note. */
  note?: Maybe<Scalars['String']>;
  /** Submenu name. */
  submenuName?: Maybe<Scalars['String']>;
  /** Subtotal. */
  subtotal: Money;
  /** Tax rate expressed as a percentage. */
  taxRate?: Maybe<Scalars['Float']>;
  /** Unit price, not including modifiers. */
  unitPrice: Money;
};

/** Consumer order line-item modifier. */
export type ConsumerOrderLineItemModifier = Node & {
  __typename?: 'ConsumerOrderLineItemModifier';
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID'];
  /** Modifier group name. */
  modifierGroupName: Scalars['String'];
  /** Modifier option name. */
  modifierOptionName: Scalars['String'];
  /** Quantity. */
  quantity: Scalars['Int'];
  /** Unit price. */
  unitPrice: Money;
};

/** Autogenerated input type of ConsumerOrderPickedUp */
export type ConsumerOrderPickedUpInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Consumer order ID. */
  consumerOrderId: Scalars['ID'];
  /**
   * Order's current lock version. If an outdated lock version is provided, the
   * operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int'];
};

/** Autogenerated return type of ConsumerOrderPickedUp */
export type ConsumerOrderPickedUpPayload = {
  __typename?: 'ConsumerOrderPickedUpPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to mark the order picked-up. */
  result: ConsumerOrderResult;
};

/** Autogenerated input type of ConsumerOrderReady */
export type ConsumerOrderReadyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Consumer order ID. */
  consumerOrderId: Scalars['ID'];
  /**
   * Order's current lock version. If an outdated lock version is provided, the
   * operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int'];
};

/** Autogenerated return type of ConsumerOrderReady */
export type ConsumerOrderReadyPayload = {
  __typename?: 'ConsumerOrderReadyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to ready the order. */
  result: ConsumerOrderResult;
};

/** Consumer order mutation result. */
export type ConsumerOrderResult = ConsumerOrderSuccess | ErrorsResult;

/** Sort criteria for a collection of consumer orders. */
export type ConsumerOrderSortCriteria = {
  /** Direction to sort in. */
  direction: SortDirection;
  /** Field to sort by. */
  field: ConsumerOrderSortField;
};

/** Fields by which consumer orders connection can be sorted. */
export enum ConsumerOrderSortField {
  /** Sort consumer orders by creation time. */
  CreatedAt = 'CREATED_AT',
  /** Sort consumer orders by pickup time. */
  PickupTime = 'PICKUP_TIME'
}

/** Result of a successful consumer order mutation. */
export type ConsumerOrderSuccess = {
  __typename?: 'ConsumerOrderSuccess';
  /** Resulting consumer order. */
  consumerOrder: ConsumerOrder;
};

export type ConsumerPostOrderSurvey = {
  __typename?: 'ConsumerPostOrderSurvey';
  /** Datetime after which the consumer post-order survey should be displayed. */
  displayAfter: Scalars['ISO8601DateTime'];
  /** The order for which the consumer post-order survey should be displayed. */
  order: ConsumerOrder;
};

/**
 * Refund Info. Due to partial refunds, it's possible to submit multiple refunds
 * for a given order. This refund info object describes the cumulative effect of
 * all the refunds that have been processed.
 */
export type ConsumerRefundInfo = {
  __typename?: 'ConsumerRefundInfo';
  /** Customer refunded fee. */
  customerRefundedFee: Money;
  /** Customer refunded subtotal. */
  customerRefundedSubtotal: Money;
  /** Customer refunded tax. */
  customerRefundedTax: Money;
  /** Customer refunded tip. */
  customerRefundedTip: Money;
  /** Customer refunded total. */
  customerRefundedTotal: Money;
  /** Customer refunded reward. */
  customerRewardValue: Money;
  /**
   * Collection describing which item units (and associated modifier units) have
   * been refunded, and which have not yet been refunded.
   */
  items: Array<ConsumerRefundInfoItem>;
};

/**
 * Refund information about a single item and its modifiers. Note that a
 * ConsumerOrderLineItem with itemQuantity N will have N distinct RefundInfoItems.
 */
export type ConsumerRefundInfoItem = {
  __typename?: 'ConsumerRefundInfoItem';
  /** Item name. */
  itemName: Scalars['String'];
  /** Item size. */
  itemSize: Scalars['String'];
  /** ID of the associated ConsumerOrderLineItem. */
  lineItemId: Scalars['ID'];
  /** Collection describing which of the item's associated modifiers have been refunded, and which have not yet been refunded. */
  modifiers: Array<ConsumerRefundInfoItemModifier>;
  /** Whether the item has been refunded. */
  refunded: Scalars['Boolean'];
  /** Unit price, not including modifiers. */
  unitPrice: Money;
};

/**
 * Refund information about a single item modifier. Note that a
 * ConsumerOrderLineItemModifier with quantity N will have N distinct
 * RefundInfoItemModifiers.
 */
export type ConsumerRefundInfoItemModifier = {
  __typename?: 'ConsumerRefundInfoItemModifier';
  /** ID of the associated ConsumerOrderLineItemModifier. */
  lineItemModifierId: Scalars['ID'];
  /** Modifier group name. */
  modifierGroupName: Scalars['String'];
  /** Modifier option name. */
  modifierOptionName: Scalars['String'];
  /** Whether the modifier has been refunded. */
  refunded: Scalars['Boolean'];
  /** Unit price. */
  unitPrice: Money;
};

/** Consumer refund calculation result. */
export type ConsumerRefundInfoResult = ConsumerRefundInfoSuccess | ErrorsResult;

/** Result of a successful consumer refund calculation. */
export type ConsumerRefundInfoSuccess = {
  __typename?: 'ConsumerRefundInfoSuccess';
  /** Resulting refund info. */
  refundInfo: ConsumerRefundInfo;
};

/** Input for refunding a single unit of a ConsumerOrderLineItem. */
export type ConsumerRefundItemInput = {
  /**
   * How many not-yet-refunded units of the line item exist prior to applying the
   * requested mutation. This must equal the number of ConsumerRefundInfoItem
   * elements that identify the line item and have refunded = false (see
   * ConsumerOrder.refundInfo.items). If the provided count is incorrect, the
   * server will assume the request was made based on outdated information and will
   * respond with an appropriate error.
   */
  currentCount: Scalars['Int'];
  /** ID of the associated ConsumerOrderLineItem. */
  lineItemId: Scalars['ID'];
};

/** Input for refunding a single unit of a ConsumerOrderLineItemModifier. */
export type ConsumerRefundModifierInput = {
  /**
   * How many not-yet-refunded units of the item modifier exist prior to applying
   * the requested mutation. This must equal the number of
   * ConsumerRefundInfoItemModifier elements that identify the item modifier and
   * have refunded = false (see ConsumerOrder.refundInfo.items.modifiers). If the
   * provided count is incorrect, the server will assume the request was made based
   * on outdated information and will respond with an appropriate error.
   */
  currentCount: Scalars['Int'];
  /** ID of the associated ConsumerOrderLineItemModifier. */
  lineItemModifierId: Scalars['ID'];
};

/** Autogenerated input type of CreateDriverVisitImageMutation */
export type CreateDriverVisitImageMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  driverVisitId: Scalars['ID'];
  s3ObjectKey: Scalars['String'];
};

/** Autogenerated return type of CreateDriverVisitImageMutation */
export type CreateDriverVisitImageMutationPayload = {
  __typename?: 'CreateDriverVisitImageMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<UserError>;
};

/** Autogenerated input type of CreateFulfillmentIssueMutation */
export type CreateFulfillmentIssueMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  issue: FulfillmentIssueIssue;
  itemId: Scalars['ID'];
  itemType: Item;
  note?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of CreateFulfillmentIssueMutation */
export type CreateFulfillmentIssueMutationPayload = {
  __typename?: 'CreateFulfillmentIssueMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<UserError>;
  id?: Maybe<Scalars['ID']>;
};

/** Autogenerated input type of CreateFullConsumerRefund */
export type CreateFullConsumerRefundInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Consumer order ID. */
  consumerOrderId: Scalars['ID'];
  /**
   * Order's current lock version. If an outdated lock version is provided, the
   * operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int'];
};

/** Autogenerated return type of CreateFullConsumerRefund */
export type CreateFullConsumerRefundPayload = {
  __typename?: 'CreateFullConsumerRefundPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to create a full consumer refund. */
  result: ConsumerOrderResult;
};

/** Autogenerated input type of CreatePartialConsumerRefund */
export type CreatePartialConsumerRefundInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Consumer order ID. */
  consumerOrderId: Scalars['ID'];
  /**
   * Order's current lock version. If an outdated lock version is provided, the
   * operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int'];
  /** Collection describing the item units to be refunded. */
  refundItemInputs: Array<ConsumerRefundItemInput>;
  /** Collection describing the modifier units to be refunded. */
  refundModifierInputs: Array<ConsumerRefundModifierInput>;
};

/** Autogenerated return type of CreatePartialConsumerRefund */
export type CreatePartialConsumerRefundPayload = {
  __typename?: 'CreatePartialConsumerRefundPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to create a partial consumer refund. */
  result: ConsumerOrderResult;
};

/** Error indicating that curbside pickup cannot be requested because merchant has not enabled curbside pickup. */
export type CurbsidePickupNotEnabled = Error & {
  __typename?: 'CurbsidePickupNotEnabled';
  /** A description of the error. */
  message: Scalars['String'];
};

export enum Currency {
  Usd = 'USD'
}

/** Range of dates */
export type DateRangeInput = {
  /** Lower bound (inclusive) of the range */
  lowerBound?: InputMaybe<Scalars['ISO8601Date']>;
  /** Upper bound of the range */
  upperBound?: InputMaybe<Scalars['ISO8601Date']>;
  /** Whether upper bound is included in the range */
  upperInclusive: Scalars['Boolean'];
};

/** The values representing each day of the week. */
export enum DayOfWeekEnum {
  /** Friday. */
  Fri = 'fri',
  /** Monday. */
  Mon = 'mon',
  /** Saturday. */
  Sat = 'sat',
  /** Sunday. */
  Sun = 'sun',
  /** Thursday. */
  Thu = 'thu',
  /** Tuesday. */
  Tue = 'tue',
  /** Wednesday. */
  Wed = 'wed'
}

/** Autogenerated input type of DeleteDriverVisitImageMutation */
export type DeleteDriverVisitImageMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  s3ObjectKey: Scalars['String'];
};

/** Autogenerated return type of DeleteDriverVisitImageMutation */
export type DeleteDriverVisitImageMutationPayload = {
  __typename?: 'DeleteDriverVisitImageMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<UserError>;
};

/** Autogenerated input type of DeleteDriverVisitPhotoMutation */
export type DeleteDriverVisitPhotoMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  image: DriverImage;
};

/** Autogenerated return type of DeleteDriverVisitPhotoMutation */
export type DeleteDriverVisitPhotoMutationPayload = {
  __typename?: 'DeleteDriverVisitPhotoMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<UserError>;
};

/** Autogenerated input type of DeleteSquareCard */
export type DeleteSquareCardInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Square card id. */
  squareCardId: Scalars['String'];
};

/** Autogenerated return type of DeleteSquareCard */
export type DeleteSquareCardPayload = {
  __typename?: 'DeleteSquareCardPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to delete Square card. */
  result: WalletResult;
};

/** Autogenerated input type of DeleteZipcodeMutation */
export type DeleteZipcodeMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  warehouseId: Scalars['ID'];
  zipcodeIds: Array<Scalars['ID']>;
};

/** Autogenerated return type of DeleteZipcodeMutation */
export type DeleteZipcodeMutationPayload = {
  __typename?: 'DeleteZipcodeMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<UserError>;
};

export type Delivery = {
  __typename?: 'Delivery';
  attachments?: Maybe<Array<Attachment>>;
  completedAt?: Maybe<Scalars['ISO8601DateTime']>;
  compostCollectedAt?: Maybe<Scalars['ISO8601DateTime']>;
  compostCollectionRequired?: Maybe<Scalars['Boolean']>;
  deliveryStatus: DeliveryStatus;
  donationCollectedAt?: Maybe<Scalars['ISO8601DateTime']>;
  donationRequired?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  issues?: Maybe<Array<Issue>>;
  location?: Maybe<Location>;
  orders?: Maybe<Array<Order>>;
  reminderMessage?: Maybe<Scalars['String']>;
  sequenceNumber?: Maybe<Scalars['String']>;
  viewedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** Autogenerated input type of DeliveryCompletedUpdate */
export type DeliveryCompletedUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  completed: Scalars['Boolean'];
  /** Delivery route stop id. */
  deliveryRouteStopId: Scalars['ID'];
};

/** Autogenerated return type of DeliveryCompletedUpdate */
export type DeliveryCompletedUpdatePayload = {
  __typename?: 'DeliveryCompletedUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  deliveryRouteStop?: Maybe<DeliveryStop>;
  userErrors: Array<DeliveryRouteStopError>;
};

/** Input for specifying delivery details. */
export type DeliveryDetailInput = {
  /** City. */
  city: Scalars['String'];
  /** Notes. */
  notes?: InputMaybe<Scalars['String']>;
  /** Postal code. */
  postalCode: Scalars['String'];
  /** State. */
  state: Scalars['String'];
  /** Street address. */
  streetAddress: Scalars['String'];
};

export enum DeliveryIssue {
  AccessIssueSecurity = 'access_issue_security',
  AlarmIssueDifficultToFind = 'alarm_issue_difficult_to_find',
  AlarmIssueInaccurateInstructions = 'alarm_issue_inaccurate_instructions',
  AlarmTriggered = 'alarm_triggered',
  CafePartnerStoreHours = 'cafe_partner_store_hours',
  DamagedInTransit = 'damaged_in_transit',
  DeliveryInstructionsInaccurate = 'delivery_instructions_inaccurate',
  DeliveryInstructionsInaccurateNonRefrigeratedItems = 'delivery_instructions_inaccurate_non_refrigerated_items',
  DeliveryInstructionsInaccurateRefrigeratedItems = 'delivery_instructions_inaccurate_refrigerated_items',
  DeliveryIssueNoRoomInFridge = 'delivery_issue_no_room_in_fridge',
  DeliveryIssueSpillDamageToStore = 'delivery_issue_spill_damage_to_store',
  DeliveryIssueUnableToAccessFridge = 'delivery_issue_unable_to_access_fridge',
  KeyIssueDoesNotWork = 'key_issue_does_not_work',
  KeyIssueLeftAtWarehouse = 'key_issue_left_at_warehouse',
  KeyIssueNotAtWarehouse = 'key_issue_not_at_warehouse',
  LockboxIssueInvalidCode = 'lockbox_issue_invalid_code',
  LockboxIssueKeyNotPresent = 'lockbox_issue_key_not_present',
  LockboxIssueNotFound = 'lockbox_issue_not_found',
  MissingItemVendorSelectItem = 'missing_item_vendor_select_item',
  MissingItemWarehouseSelectItem = 'missing_item_warehouse_select_item',
  MissingItemWrongItem = 'missing_item_wrong_item',
  NoOrderAtVendor = 'no_order_at_vendor',
  NoPickUpAvailableCompost = 'no_pick_up_available_compost',
  NoPickUpAvailableDonation = 'no_pick_up_available_donation',
  NoPickUpAvailableReturn = 'no_pick_up_available_return',
  NoPickUpAvailableTransfer = 'no_pick_up_available_transfer',
  NoPickUpAvailableVendor = 'no_pick_up_available_vendor',
  Other = 'other',
  PestOrRodents = 'pest_or_rodents',
  UnableToAccessLocation = 'unable_to_access_location',
  WeatherIssue = 'weather_issue'
}

/** Autogenerated input type of DeliveryIssueCreate */
export type DeliveryIssueCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Delivery route stop id. */
  deliveryRouteStopId: Scalars['ID'];
  /** Additional details on the delivery issue */
  note: Scalars['String'];
  /** Order id. */
  orderId?: InputMaybe<Scalars['ID']>;
  /** Type of the delivery issue. */
  type: DeliveryIssue;
};

/** Autogenerated return type of DeliveryIssueCreate */
export type DeliveryIssueCreatePayload = {
  __typename?: 'DeliveryIssueCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  issue?: Maybe<Issue>;
  userErrors: Array<DeliveryIssueError>;
};

/** Autogenerated input type of DeliveryIssueDelete */
export type DeliveryIssueDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Delivery issue id. */
  id: Scalars['ID'];
};

/** Autogenerated return type of DeliveryIssueDelete */
export type DeliveryIssueDeletePayload = {
  __typename?: 'DeliveryIssueDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  userErrors: Array<DeliveryIssueError>;
};

export type DeliveryIssueDuplicate = BusinessError & {
  __typename?: 'DeliveryIssueDuplicate';
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

/** Delivery issue possible errors */
export type DeliveryIssueError = DeliveryIssueDuplicate | DeliveryIssueNotFound | OrderNotFound;

export type DeliveryIssueNotFound = BusinessError & {
  __typename?: 'DeliveryIssueNotFound';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated input type of DeliveryIssueUpdate */
export type DeliveryIssueUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Delivery issue id. */
  id: Scalars['ID'];
  /** Additional details on the delivery issue */
  note: Scalars['String'];
  /** Type of the delivery issue. */
  type: DeliveryIssue;
};

/** Autogenerated return type of DeliveryIssueUpdate */
export type DeliveryIssueUpdatePayload = {
  __typename?: 'DeliveryIssueUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  issue: Issue;
  userErrors: Array<DeliveryIssueError>;
};

export type DeliveryRoute = {
  __typename?: 'DeliveryRoute';
  assignedDriverName?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  deliveryRouteVisits: Array<DeliveryRouteVisit>;
  id: Scalars['ID'];
  name: Scalars['String'];
  orderedDeliveryRouteVisits: Array<DeliveryRouteVisit>;
  /** This is visits filtered by date */
  orderedDriverVisits: Array<DriverVisit>;
  updatedAt: Scalars['ISO8601DateTime'];
  vendorVisits: Array<VendorVisit>;
  warehouse?: Maybe<Warehouse>;
};


export type DeliveryRouteAssignedDriverNameArgs = {
  visitDate?: InputMaybe<Scalars['ISO8601DateTime']>;
};


export type DeliveryRouteOrderedDeliveryRouteVisitsArgs = {
  visitDate: Scalars['ISO8601DateTime'];
};


export type DeliveryRouteOrderedDriverVisitsArgs = {
  visitDate: Scalars['ISO8601DateTime'];
};


export type DeliveryRouteVendorVisitsArgs = {
  visitDate: Scalars['ISO8601DateTime'];
};

/** Autogenerated input type of DeliveryRouteCreate */
export type DeliveryRouteCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Delivery route name. */
  name?: InputMaybe<Scalars['String']>;
  /** Delivery Route night end. */
  nightEnd: Scalars['ISO8601Date'];
  /** Warehouse id. */
  warehouseId: Scalars['ID'];
};

/** Autogenerated return type of DeliveryRouteCreate */
export type DeliveryRouteCreatePayload = {
  __typename?: 'DeliveryRouteCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  route?: Maybe<Route>;
  userErrors: Array<RouteError>;
};

export type DeliveryRouteNotFoundError = BusinessError & {
  __typename?: 'DeliveryRouteNotFoundError';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated input type of DeliveryRouteStopAttachmentCreate */
export type DeliveryRouteStopAttachmentCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Delivery route stop id. */
  deliveryRouteStopId: Scalars['ID'];
  objectKey: Scalars['String'];
};

/** Autogenerated return type of DeliveryRouteStopAttachmentCreate */
export type DeliveryRouteStopAttachmentCreatePayload = {
  __typename?: 'DeliveryRouteStopAttachmentCreatePayload';
  attachment?: Maybe<Attachment>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  userErrors: Array<DeliveryRouteStopError>;
};

/** Autogenerated input type of DeliveryRouteStopAttachmentDelete */
export type DeliveryRouteStopAttachmentDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Delivery route stop id. */
  deliveryRouteStopId: Scalars['ID'];
  objectKey: Scalars['String'];
};

/** Autogenerated return type of DeliveryRouteStopAttachmentDelete */
export type DeliveryRouteStopAttachmentDeletePayload = {
  __typename?: 'DeliveryRouteStopAttachmentDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  userErrors: Array<DeliveryRouteStopError>;
};

/** Autogenerated input type of DeliveryRouteStopCompostCollectedUpdate */
export type DeliveryRouteStopCompostCollectedUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  collected: Scalars['Boolean'];
  /** Delivery route stop id. */
  deliveryRouteStopId: Scalars['ID'];
};

/** Autogenerated return type of DeliveryRouteStopCompostCollectedUpdate */
export type DeliveryRouteStopCompostCollectedUpdatePayload = {
  __typename?: 'DeliveryRouteStopCompostCollectedUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  deliveryRouteStop?: Maybe<DeliveryStop>;
  userErrors: Array<DeliveryRouteStopError>;
};

/** Autogenerated input type of DeliveryRouteStopDonationCollectedUpdate */
export type DeliveryRouteStopDonationCollectedUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  collected: Scalars['Boolean'];
  /** Delivery route stop id. */
  deliveryRouteStopId: Scalars['ID'];
};

/** Autogenerated return type of DeliveryRouteStopDonationCollectedUpdate */
export type DeliveryRouteStopDonationCollectedUpdatePayload = {
  __typename?: 'DeliveryRouteStopDonationCollectedUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  deliveryRouteStop?: Maybe<DeliveryStop>;
  userErrors: Array<DeliveryRouteStopError>;
};

/** Delivery route stop possible error types */
export type DeliveryRouteStopError = DeliveryRouteNotFoundError | DeliveryRouteStopInvalidSequenceNumber | DeliveryRouteStopNotFound | InvalidNightEnd;

export type DeliveryRouteStopInvalidSequenceNumber = BusinessError & {
  __typename?: 'DeliveryRouteStopInvalidSequenceNumber';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type DeliveryRouteStopNotFound = BusinessError & {
  __typename?: 'DeliveryRouteStopNotFound';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated input type of DeliveryRouteStopReminderUpdate */
export type DeliveryRouteStopReminderUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Driver reminder message for the stop. */
  message: Scalars['String'];
  /** Delivery route stop id. */
  stopId: Scalars['ID'];
};

/** Autogenerated return type of DeliveryRouteStopReminderUpdate */
export type DeliveryRouteStopReminderUpdatePayload = {
  __typename?: 'DeliveryRouteStopReminderUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  stop?: Maybe<DeliveryStop>;
  userErrors: Array<DeliveryRouteStopError>;
};

/** Autogenerated input type of DeliveryRouteStopViewedAtUpdate */
export type DeliveryRouteStopViewedAtUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** delivery route stop id. */
  deliveryRouteStopId: Scalars['ID'];
};

/** Autogenerated return type of DeliveryRouteStopViewedAtUpdate */
export type DeliveryRouteStopViewedAtUpdatePayload = {
  __typename?: 'DeliveryRouteStopViewedAtUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  deliveryRouteStop?: Maybe<DeliveryStop>;
  userErrors: Array<DeliveryRouteStopError>;
};

export type DeliveryRouteVisit = {
  __typename?: 'DeliveryRouteVisit';
  id: Scalars['ID'];
  nightEnd: Scalars['ISO8601Date'];
  nightStart: Scalars['ISO8601Date'];
  routeOrder: Scalars['Int'];
  visitable: DeliveryRouteVisitable;
};

export type DeliveryRouteVisitable = DriverVisit | VendorVisit;

export enum DeliveryStatus {
  /** delivery route stop is marked completed and has no issues and all orders delivered */
  Done = 'done',
  /**
   * delivery route stop has at least one delivery issue or at least one order is not marked
   * delivered.
   */
  Error = 'error',
  /** Delivery route stop has not been viewed by a driver */
  New = 'new'
}

/** Delivery stop */
export type DeliveryStop = Delivery | PickUp;

/** Autogenerated input type of DeliveryStopsMoveToRoute */
export type DeliveryStopsMoveToRouteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Delivery route id you would like to move the stops to. */
  routeId: Scalars['ID'];
  /** ID of the stop you would like to move. */
  stopIds: Array<Scalars['ID']>;
};

/** Autogenerated return type of DeliveryStopsMoveToRoute */
export type DeliveryStopsMoveToRoutePayload = {
  __typename?: 'DeliveryStopsMoveToRoutePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  updatedRoutes?: Maybe<Array<Route>>;
  userErrors: Array<DeliveryRouteStopError>;
};

/** Autogenerated input type of DeliveryStopsReorder */
export type DeliveryStopsReorderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The sequence number you would like to move your stop to on the specified route. */
  destinationSequenceNumber: Scalars['Int'];
  /** Delivery route id. */
  routeId: Scalars['ID'];
  /** Stop id you would like to move. */
  stopId: Scalars['ID'];
};

/** Autogenerated return type of DeliveryStopsReorder */
export type DeliveryStopsReorderPayload = {
  __typename?: 'DeliveryStopsReorderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  route?: Maybe<Route>;
  userErrors: Array<DeliveryRouteStopError>;
};

/** Autogenerated input type of DiscardFulfillmentIssueMutation */
export type DiscardFulfillmentIssueMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  fulfillmentIssueId: Scalars['ID'];
};

/** Autogenerated return type of DiscardFulfillmentIssueMutation */
export type DiscardFulfillmentIssueMutationPayload = {
  __typename?: 'DiscardFulfillmentIssueMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<UserError>;
};

export type Driver = {
  __typename?: 'Driver';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export enum DriverImage {
  /** First Image */
  ImageOne = 'image_one',
  /** Second Image */
  ImageTwo = 'image_two'
}

export type DriverVisit = {
  __typename?: 'DriverVisit';
  deliveryRoute: DeliveryRoute;
  driverVisitImages: Array<DriverVisitImage>;
  exitAt?: Maybe<Scalars['ISO8601DateTime']>;
  exitInstructions: Scalars['String'];
  fulfillmentIssues: Array<FulfillmentIssue>;
  id: Scalars['ID'];
  imageOneUrl?: Maybe<Scalars['String']>;
  imageTwoUrl?: Maybe<Scalars['String']>;
  location: Location;
  nightEnd: Scalars['ISO8601Date'];
  nightStart: Scalars['ISO8601Date'];
  reminderMessage?: Maybe<Scalars['String']>;
  routeOrder: Scalars['Int'];
  serviceTaskGroups: Array<ServiceTaskGroup>;
  visitStatus: VisitStatus;
};

export type DriverVisitImage = {
  __typename?: 'DriverVisitImage';
  s3ObjectKey: Scalars['String'];
  url: Scalars['String'];
};

/**
 * Error indicating that a mutation whose input requires a collection of unique
 * elements failed because the provided collection contained duplicates.
 */
export type DuplicateInputError = Error & {
  __typename?: 'DuplicateInputError';
  /** ID of duplicate element. */
  id: Scalars['ID'];
  /** A description of the error. */
  message: Scalars['String'];
};

/** Error indicating the requested email address is already in use. */
export type EmailAlreadyTaken = Error & {
  __typename?: 'EmailAlreadyTaken';
  /** A description of the error. */
  message: Scalars['String'];
};

/** Error indicating an empty cart caused an operation to fail. */
export type EmptyCartError = Error & {
  __typename?: 'EmptyCartError';
  /** A description of the error. */
  message: Scalars['String'];
};

/** The name of the ERP platform. Currently only NetSuite is supported. */
export enum ErpPlatform {
  Netsuite = 'NETSUITE'
}

/** The name of an ERP record type, as understood by the ERP. */
export enum ErpRecord {
  Item = 'ITEM',
  SalesOrder = 'SALES_ORDER'
}

/** Error. */
export type Error = {
  /** A description of the error. */
  message: Scalars['String'];
};

export type ErrorUpdatingItemPrices = Error & {
  __typename?: 'ErrorUpdatingItemPrices';
  /** A description of the error. */
  message: Scalars['String'];
};

/** Collection of one or more errors. */
export type Errors = {
  __typename?: 'Errors';
  /** First error. */
  head: Error;
  /** List (possibly empty) of additional errors. */
  tail: Array<Error>;
};

/** Result of an operation that failed due to one or more errors. */
export type ErrorsResult = {
  __typename?: 'ErrorsResult';
  /** Non-empty collection of errors that occurred. */
  errors: Errors;
};

/** Favorite consumer order. */
export type FavoriteConsumerOrder = Node & {
  __typename?: 'FavoriteConsumerOrder';
  /** Icon. */
  icon?: Maybe<Scalars['String']>;
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID'];
  /** Name. */
  name?: Maybe<Scalars['String']>;
  /** Consumer order. */
  order: ConsumerOrder;
};

/** Favorite consumer order mutation result. */
export type FavoriteConsumerOrderResult = ErrorsResult | FavoriteConsumerOrderSuccess;

/** Result of a successful favorite consumer order mutation. */
export type FavoriteConsumerOrderSuccess = {
  __typename?: 'FavoriteConsumerOrderSuccess';
  /** Resulting favorite consumer order. */
  favoriteConsumerOrder: FavoriteConsumerOrder;
};

export type FulfillmentIssue = {
  __typename?: 'FulfillmentIssue';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  issue: FulfillmentIssueIssue;
  note?: Maybe<Scalars['String']>;
};

export enum FulfillmentIssueIssue {
  AccessIssueSecurity = 'access_issue_security',
  AlarmIssueDifficultToFind = 'alarm_issue_difficult_to_find',
  AlarmIssueInaccurateInstructions = 'alarm_issue_inaccurate_instructions',
  AlarmTriggered = 'alarm_triggered',
  CafePartnerStoreHours = 'cafe_partner_store_hours',
  DamagedInTransit = 'damaged_in_transit',
  DeliveryInstructionsInaccurate = 'delivery_instructions_inaccurate',
  DeliveryInstructionsInaccurateNonRefrigeratedItems = 'delivery_instructions_inaccurate_non_refrigerated_items',
  DeliveryInstructionsInaccurateRefrigeratedItems = 'delivery_instructions_inaccurate_refrigerated_items',
  DeliveryIssueNoRoomInFridge = 'delivery_issue_no_room_in_fridge',
  DeliveryIssueSpillDamageToStore = 'delivery_issue_spill_damage_to_store',
  DeliveryIssueUnableToAccessFridge = 'delivery_issue_unable_to_access_fridge',
  KeyIssueDoesNotWork = 'key_issue_does_not_work',
  KeyIssueLeftAtWarehouse = 'key_issue_left_at_warehouse',
  KeyIssueNotAtWarehouse = 'key_issue_not_at_warehouse',
  LockboxIssueInvalidCode = 'lockbox_issue_invalid_code',
  LockboxIssueKeyNotPresent = 'lockbox_issue_key_not_present',
  LockboxIssueNotFound = 'lockbox_issue_not_found',
  MissingItemVendorSelectItem = 'missing_item_vendor_select_item',
  MissingItemWarehouseSelectItem = 'missing_item_warehouse_select_item',
  MissingItemWrongItem = 'missing_item_wrong_item',
  NoOrderAtVendor = 'no_order_at_vendor',
  NoPickUpAvailableCompost = 'no_pick_up_available_compost',
  NoPickUpAvailableDonation = 'no_pick_up_available_donation',
  NoPickUpAvailableReturn = 'no_pick_up_available_return',
  NoPickUpAvailableTransfer = 'no_pick_up_available_transfer',
  NoPickUpAvailableVendor = 'no_pick_up_available_vendor',
  Other = 'other',
  PestOrRodents = 'pest_or_rodents',
  UnableToAccessLocation = 'unable_to_access_location',
  WeatherIssue = 'weather_issue'
}

/** Autogenerated input type of GeneratePresignedUrlMutation */
export type GeneratePresignedUrlMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of GeneratePresignedUrlMutation */
export type GeneratePresignedUrlMutationPayload = {
  __typename?: 'GeneratePresignedUrlMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<UserError>;
  objectKey?: Maybe<Scalars['String']>;
  presignedReadUrl?: Maybe<Scalars['String']>;
  presignedUrl?: Maybe<Scalars['String']>;
};

/** Geographic coordinates */
export type GeographicCoordinates = {
  /** Latitude */
  latitude: Scalars['Float'];
  /** Longitude */
  longitude: Scalars['Float'];
};

/** Circular geospatial region */
export type GeospatialCircle = {
  /** Center point */
  center: GeographicCoordinates;
  /** Radius, in miles */
  radius: Scalars['Int'];
};

/** Range of Ints */
export type IntRangeInput = {
  /** Lower bound (inclusive) of the range */
  lowerBound?: InputMaybe<Scalars['Int']>;
  /** Upper bound of the range */
  upperBound?: InputMaybe<Scalars['Int']>;
  /** Whether upper bound is included in the range */
  upperInclusive: Scalars['Boolean'];
};

export type InternalDeliveryInstructions = {
  __typename?: 'InternalDeliveryInstructions';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  imageKeys?: Maybe<Array<Scalars['String']>>;
  imageUrls?: Maybe<Array<Scalars['String']>>;
  location: Location;
  note?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type InternalLoopRequest = {
  __typename?: 'InternalLoopRequest';
  fromInstructions: Scalars['String'];
  fromName: Scalars['String'];
  id: Scalars['ID'];
  toInstructions: Scalars['String'];
  toName: Scalars['String'];
};

export type InternalLoopServiceTask = ServiceTask & {
  __typename?: 'InternalLoopServiceTask';
  fulfilledAt?: Maybe<Scalars['ISO8601DateTime']>;
  fulfillmentIssues: Array<FulfillmentIssue>;
  id: Scalars['ID'];
  internalLoopRequest: InternalLoopRequest;
  serviceTaskMessage?: Maybe<ServiceTaskMessage>;
  taskType: Task;
};

export type InternalLoopVendorTask = VendorTask & {
  __typename?: 'InternalLoopVendorTask';
  fulfilledAt?: Maybe<Scalars['ISO8601DateTime']>;
  fulfillmentIssues: Array<FulfillmentIssue>;
  id: Scalars['ID'];
  internalLoopRequest: InternalLoopRequest;
  note?: Maybe<Scalars['String']>;
  serviceTaskOrder?: Maybe<ServiceTaskOrder>;
  taskType: CafeAction;
  vendorVisit: VendorVisit;
};

/** Error indicating a provided cart input value was invalid. */
export type InvalidCartInputError = Error & {
  __typename?: 'InvalidCartInputError';
  /** A description of the error. */
  message: Scalars['String'];
};

/** Error indicating invalid config attributes */
export type InvalidConfigError = {
  __typename?: 'InvalidConfigError';
  /** The specific errors */
  errors: Array<UserError>;
};

export type InvalidNightEnd = BusinessError & {
  __typename?: 'InvalidNightEnd';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export enum InventoryCheckBehavior {
  Check = 'CHECK',
  Skip = 'SKIP'
}

/**
 * An InventoryItem is an item that lives in a Warehouse.
 * It features fields specific to warehouse inventory management like upc codes
 * and stock units.
 */
export type InventoryItem = SupplyItem & {
  __typename?: 'InventoryItem';
  brandName: Scalars['String'];
  /** (Package Height x Package Width x Package Length)/DIM factor */
  caseDimensionalWeightLbs?: Maybe<Scalars['Float']>;
  caseHeightInches?: Maybe<Scalars['Float']>;
  caseLengthInches?: Maybe<Scalars['Float']>;
  caseVolumeCuInches?: Maybe<Scalars['Float']>;
  caseWeightLbs?: Maybe<Scalars['Float']>;
  caseWidthInches?: Maybe<Scalars['Float']>;
  catalogStatus: CatalogStatus;
  category: Category;
  createdAt: Scalars['ISO8601DateTime'];
  createdBy: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  /**
   * Drives pricing with carriers like FedEx.
   * This data is uploaded from Cubiscan dimensioning device to optimize shipping costs.
   */
  dimensionalFactor?: Maybe<Scalars['Float']>;
  /** (Package Height x Package Width x Package Length)/DIM factor */
  eachDimensionalWeightLbs?: Maybe<Scalars['Float']>;
  eachHeightInches?: Maybe<Scalars['Float']>;
  eachLengthInches?: Maybe<Scalars['Float']>;
  eachVolumeCuInches?: Maybe<Scalars['Float']>;
  eachWeightLbs?: Maybe<Scalars['Float']>;
  eachWidthInches?: Maybe<Scalars['Float']>;
  erpPlatform?: Maybe<ErpPlatform>;
  erpRecordId?: Maybe<Scalars['ID']>;
  erpRecordType?: Maybe<ErpRecord>;
  erpRecordUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imgUrl?: Maybe<Scalars['String']>;
  inventoryCheckBehavior?: Maybe<InventoryCheckBehavior>;
  itemLocationsCustomPrice?: Maybe<Array<ItemLocationCustomPrice>>;
  itemSize?: Maybe<Scalars['String']>;
  locationShelfLifeDays?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  perishability?: Maybe<Perishability>;
  purchasePrice: Money;
  purchaseUnit: Unit;
  refrigerationState?: Maybe<RefrigerationState>;
  saleUnit: Unit;
  sampleUnit?: Maybe<Unit>;
  shelfLifeDays?: Maybe<Scalars['Int']>;
  standingOrderBehavior: StandingOrderBehavior;
  stockUnit?: Maybe<Unit>;
  subcategory?: Maybe<Category>;
  transitMethod?: Maybe<TransitMethod>;
  upcCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  updatedAt: Scalars['ISO8601DateTime'];
  updatedBy: Scalars['String'];
  vendorCode?: Maybe<Scalars['String']>;
  warehouseAssociation?: Maybe<Array<Maybe<InventoryWarehouseAssociation>>>;
};


/**
 * An InventoryItem is an item that lives in a Warehouse.
 * It features fields specific to warehouse inventory management like upc codes
 * and stock units.
 */
export type InventoryItemWarehouseAssociationArgs = {
  warehouseIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type InventoryItemInput = {
  brandName: Scalars['String'];
  caseHeightInches?: InputMaybe<Scalars['Float']>;
  caseLengthInches?: InputMaybe<Scalars['Float']>;
  caseWeightLbs?: InputMaybe<Scalars['Float']>;
  caseWidthInches?: InputMaybe<Scalars['Float']>;
  catalogStatus: CatalogStatus;
  category: Scalars['ID'];
  description?: InputMaybe<Scalars['String']>;
  dimensionalFactor?: InputMaybe<Scalars['Float']>;
  eachHeightInches?: InputMaybe<Scalars['Float']>;
  eachLengthInches?: InputMaybe<Scalars['Float']>;
  eachWeightLbs?: InputMaybe<Scalars['Float']>;
  eachWidthInches?: InputMaybe<Scalars['Float']>;
  imgUrl?: InputMaybe<Scalars['String']>;
  inventoryCheckBehavior?: InputMaybe<InventoryCheckBehavior>;
  itemSize?: InputMaybe<Scalars['String']>;
  locationShelfLifeDays?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  perishability?: InputMaybe<Perishability>;
  purchasePrice: MoneyInput;
  purchaseUnit: Scalars['ID'];
  refrigerationState?: InputMaybe<RefrigerationState>;
  saleUnit: Scalars['ID'];
  sampleUnit?: InputMaybe<Scalars['ID']>;
  shelfLifeDays?: InputMaybe<Scalars['Int']>;
  standingOrderBehavior: StandingOrderBehavior;
  stockUnit?: InputMaybe<Scalars['ID']>;
  subcategory?: InputMaybe<Scalars['ID']>;
  transitMethod?: InputMaybe<TransitMethod>;
  upcCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  vendorCode?: InputMaybe<Scalars['String']>;
  warehouseAssociation?: InputMaybe<Array<InputMaybe<InventoryWarehouseAssociationInput>>>;
};

/**
 * Inventory items are items we procure from some vendor and ship from our warehouse.
 * They are *stored* in the warehouse.
 */
export type InventoryWarehouseAssociation = {
  __typename?: 'InventoryWarehouseAssociation';
  hasSample?: Maybe<Scalars['Boolean']>;
  item: InventoryItem;
  landedCost?: Maybe<Money>;
  procurementVendor?: Maybe<ProcurementVendor>;
  salePrice?: Maybe<Money>;
  sample?: Maybe<SupplyItem>;
  warehouse: Warehouse;
};

export type InventoryWarehouseAssociationInput = {
  hasSample?: InputMaybe<Scalars['Boolean']>;
  procurementVendorId?: InputMaybe<Scalars['ID']>;
  salePrice: MoneyInput;
  warehouseId: Scalars['ID'];
};

export type Issue = {
  __typename?: 'Issue';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export enum Item {
  DriverVisit = 'DriverVisit',
  ServiceTask = 'ServiceTask',
  VendorTask = 'VendorTask'
}

/** Relay-style cursor-based pagination structure for Categories */
export type ItemConnection = {
  __typename?: 'ItemConnection';
  edges: Array<Maybe<ItemEdge>>;
  nodes: Array<Maybe<SupplyItem>>;
  pageInfo: PageInfo;
};

export type ItemDeliveryInstructions = {
  __typename?: 'ItemDeliveryInstructions';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  imageKeys?: Maybe<Array<Scalars['String']>>;
  imageUrls?: Maybe<Array<Scalars['String']>>;
  location: Location;
  note?: Maybe<Scalars['String']>;
  type?: Maybe<ItemDeliveryInstructionsType>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export enum ItemDeliveryInstructionsType {
  NonRefrigerated = 'non_refrigerated',
  Refrigerated = 'refrigerated'
}

export type ItemEdge = {
  __typename?: 'ItemEdge';
  cursor: Scalars['String'];
  node: SupplyItem;
};

export type ItemLocationCustomPrice = {
  __typename?: 'ItemLocationCustomPrice';
  customPrice?: Maybe<Money>;
  location?: Maybe<Location>;
};

export type ItemPricesResult = ErrorsResult | ItemPricesSuccess;

export type ItemPricesSuccess = {
  __typename?: 'ItemPricesSuccess';
  updatedItemsCount: Scalars['Int'];
  updatedWarehouseItemsCount: Scalars['Int'];
};

export enum ItemType {
  Inventory = 'INVENTORY',
  NonInventory = 'NON_INVENTORY'
}

export type ItemsCategoryInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export enum ItemsSortOrder {
  BrandAsc = 'BRAND_ASC',
  BrandDesc = 'BRAND_DESC',
  CategoryAsc = 'CATEGORY_ASC',
  CategoryDesc = 'CATEGORY_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type ItemsSubcategoryInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type ItemsVendorInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type ItemsWarehouseInput = {
  id?: InputMaybe<Scalars['ID']>;
};

/** JWT session. */
export type JwtSession = {
  __typename?: 'JwtSession';
  /** Access token. */
  access: Scalars['String'];
  /** Access token expiration. */
  accessExpiresAt: Scalars['String'];
  /** CSRF token. */
  csrf: Scalars['String'];
  /** Refresh token. */
  refresh: Scalars['String'];
  /** Refresh token expiration. */
  refreshExpiresAt: Scalars['String'];
};

export type Location = {
  __typename?: 'Location';
  address: Address;
  adequatelyPaid: Scalars['Boolean'];
  businessName: Scalars['String'];
  countryCode: Scalars['String'];
  county: Scalars['String'];
  customPrice?: Maybe<Money>;
  displayAddress: Scalars['String'];
  enabled: Scalars['Boolean'];
  encryptedLocationId?: Maybe<Scalars['String']>;
  formattedAddress: Scalars['String'];
  hasDeliveries?: Maybe<Scalars['Boolean']>;
  hasOrders?: Maybe<Scalars['Boolean']>;
  hasSkus?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  internalDeliveryInstructions?: Maybe<Array<InternalDeliveryInstructions>>;
  itemDeliveryInstructions?: Maybe<Array<ItemDeliveryInstructions>>;
  keyId: Scalars['String'];
  locationAccessInstructions?: Maybe<Array<LocationAccessInstructions>>;
  locationDeliveryWindow: LocationDeliveryWindows;
  locationEntranceInstructions?: Maybe<Array<LocationEntranceInstructions>>;
  name: Scalars['String'];
  netsuiteInternalId: Scalars['ID'];
  /** Get a Netsuite transactions filtered */
  netsuiteTransactions?: Maybe<Array<NetsuiteTransaction>>;
  nickname: Scalars['String'];
  onboardingStatus?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state: Scalars['String'];
  timeZone: Scalars['String'];
  warehouse: Warehouse;
};


export type LocationNetsuiteTransactionsArgs = {
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  transactionTypes?: InputMaybe<Array<Scalars['String']>>;
  vendorName?: InputMaybe<Scalars['String']>;
};

export type LocationAccessInstructions = {
  __typename?: 'LocationAccessInstructions';
  code?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  imageKeys?: Maybe<Array<Scalars['String']>>;
  imageUrls?: Maybe<Array<Scalars['String']>>;
  installed?: Maybe<Scalars['Boolean']>;
  location: Location;
  note?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for Location. */
export type LocationConnection = {
  __typename?: 'LocationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LocationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Location>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type LocationDeliveryWindows = {
  __typename?: 'LocationDeliveryWindows';
  /** End time in HH:MM format. */
  endTime: Scalars['String'];
  /** Start time in HH:MM format. */
  startTime: Scalars['String'];
};

/** An edge in a connection. */
export type LocationEdge = {
  __typename?: 'LocationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Location>;
};

export type LocationEntranceInstructions = {
  __typename?: 'LocationEntranceInstructions';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  imageKeys?: Maybe<Array<Scalars['String']>>;
  imageUrls?: Maybe<Array<Scalars['String']>>;
  location: Location;
  note?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
  videoKeys?: Maybe<Array<Scalars['String']>>;
  videoUrls?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated input type of LoginConsumerAppUserFromFirebase */
export type LoginConsumerAppUserFromFirebaseInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Email to assign if registering a new account. Must be non-null if registering a new account. */
  email?: InputMaybe<Scalars['String']>;
  /** Firebase ID (the "localId" received from www.googleapis.com/identitytoolkit/v3/relyingparty/getAccountInfo). */
  fbId: Scalars['String'];
  /** Firebase token to assign if registering a new account. */
  fbToken?: InputMaybe<Scalars['String']>;
  /** Whether this should be registered as a guest account, if registering a new account. Defaults to false. */
  isGuestAccount?: InputMaybe<Scalars['Boolean']>;
  /** Phone number to assign if registering a new account. */
  phoneNumber?: InputMaybe<Scalars['String']>;
  /** ID received when verifying phone number. Must be included if a non-null "phoneNumber" is specified. */
  phoneVerificationId?: InputMaybe<Scalars['ID']>;
  /** Username to assign if registering a new account. Must be non-null if registering a new account. */
  username?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of LoginConsumerAppUserFromFirebase */
export type LoginConsumerAppUserFromFirebasePayload = {
  __typename?: 'LoginConsumerAppUserFromFirebasePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to login. */
  result: ConsumerAppUserFirebaseLoginResult;
};

/** Menu. */
export type Menu = Node & {
  __typename?: 'Menu';
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID'];
  /** Menu's current lock version, providing concurrency control and protection against stale updates. */
  lockVersion: Scalars['Int'];
  /** Name. */
  name: Scalars['String'];
  /** The order of the menu in the UI. */
  sortOrder: Scalars['Int'];
  /** Submenus. */
  submenus: Array<Submenu>;
  /** Visibility. */
  visibility: Visibility;
};

/** Menu item. */
export type MenuItem = Node & {
  __typename?: 'MenuItem';
  /** Description. */
  description: Scalars['String'];
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID'];
  /** Menu item's current lock version, providing concurrency control and protection against stale updates. */
  lockVersion: Scalars['Int'];
  /** Modifier groups for the menu item. */
  menuItemModifierGroups: Array<MenuItemModifierGroup>;
  /** Menu item sizes. */
  menuItemSizes: Array<MenuItemSize>;
  /** Name. */
  name: Scalars['String'];
  /** The order of the menu item in the UI. */
  sortOrder: Scalars['Int'];
  /** Visibility. */
  visibility: Visibility;
};

/** Menu item modifier group. */
export type MenuItemModifierGroup = Node & {
  __typename?: 'MenuItemModifierGroup';
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID'];
  /** Maximum selections. */
  maximumSelections?: Maybe<Scalars['Int']>;
  /** Menu item modifier options for this group. */
  menuItemModifierOptions: Array<MenuItemModifierOption>;
  /** Minimum selections. */
  minimumSelections: Scalars['Int'];
  /** Name. */
  name: Scalars['String'];
};

/** Menu item modifier option. */
export type MenuItemModifierOption = Node & {
  __typename?: 'MenuItemModifierOption';
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID'];
  /** Name. */
  name: Scalars['String'];
  /** Price. */
  price: Money;
};

/** MenuItem mutation result. */
export type MenuItemResult = ErrorsResult | MenuItemSuccess;

/** Menu item size. */
export type MenuItemSize = Node & {
  __typename?: 'MenuItemSize';
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID'];
  /** Name. */
  name: Scalars['String'];
  /** Unit price. */
  price: Money;
};

/** Result of a successful menu-item mutation. */
export type MenuItemSuccess = {
  __typename?: 'MenuItemSuccess';
  /** Resulting menu-item. */
  menuItem: MenuItem;
};

export type MenuItemsForMerchant = {
  __typename?: 'MenuItemsForMerchant';
  /** List of relevant menu items belonging to merchant. */
  menuItems: Array<MenuItem>;
  /** Merchant. */
  merchant: Merchant;
};

/** Result of mutating a list of menu items. */
export type MenuItemsResult = ErrorsResult | MenuItemsSuccess;

/** Result of successfully mutating a list of menu items. */
export type MenuItemsSuccess = {
  __typename?: 'MenuItemsSuccess';
  /** Resulting menu-items. */
  menuItems: Array<MenuItem>;
};

/** Menu mutation result. */
export type MenuResult = ErrorsResult | MenuSuccess;

/** Result of a successful menu mutation. */
export type MenuSuccess = {
  __typename?: 'MenuSuccess';
  /** Resulting menu. */
  menu: Menu;
};

/** Result of mutating a list of menus. */
export type MenusResult = ErrorsResult | MenusSuccess;

/** Result of successfully mutating a list of menus. */
export type MenusSuccess = {
  __typename?: 'MenusSuccess';
  /** Resulting menus. */
  menus: Array<Menu>;
};

/** Merchant. */
export type Merchant = Node & {
  __typename?: 'Merchant';
  /** Top-level company the merchant belongs to. */
  business: Business;
  /** Cover photo URLs. */
  coverPhotoUrls: Array<Scalars['String']>;
  /** Whether curbside pickup is offered. */
  curbsidePickup: Scalars['Boolean'];
  /** The primary key from the database. */
  databaseId: Scalars['Int'];
  /** Display address */
  displayAddress: Scalars['String'];
  /** Full address */
  fullAddress: Scalars['String'];
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID'];
  /** Latitude. */
  latitude: Scalars['Float'];
  /** Merchant's current lock version, providing concurrency control and protection against stale updates. */
  lockVersion: Scalars['Int'];
  /** Logo URL. */
  logoUrl?: Maybe<Scalars['String']>;
  /** Longitude. */
  longitude: Scalars['Float'];
  /** Menus. */
  menus: Array<Menu>;
  /** Minimum notice an order can be placed in advance of its pickup time. */
  minimumNotice: RelativeTime;
  /** Modifier groups. */
  modifierGroups: Array<ModifierGroup>;
  /** Name */
  name: Scalars['String'];
  /** In-app notification sound */
  notificationSound: Scalars['String'];
  /** Hours of operation in merchant's time zone. Order pickup times cannot be outside the bounds described by these hours. */
  operatingHours: Array<OperatingHoursForDayOfWeek>;
  /** Operating status info. */
  operatingStatus: MerchantOperatingStatus;
  /** Maximum number of days an order can be placed in advance of its pickup time. */
  orderAheadNumDays: Scalars['Int'];
  /** Order queue. */
  orderQueue: OrderQueue;
  /** Phone number. */
  phone?: Maybe<Scalars['String']>;
  /** @deprecated See the minimumNotice field instead. */
  pickupDelayMinutes: Scalars['Int'];
  /** Pickup text. */
  pickupText?: Maybe<Scalars['String']>;
  /** Street address */
  streetAddress: Scalars['String'];
  /** Time zone. */
  timezone: Scalars['String'];
  /** Whether tips are enabled. */
  tipsEnabled: Scalars['Boolean'];
};


/** Merchant. */
export type MerchantMenusArgs = {
  includeEmpty?: InputMaybe<Scalars['Boolean']>;
  includeHidden?: InputMaybe<Scalars['Boolean']>;
};


/** Merchant. */
export type MerchantOrderQueueArgs = {
  asOf?: InputMaybe<Scalars['ISO8601DateTime']>;
};

/** Merchant app viewer information. */
export type MerchantAppUser = {
  __typename?: 'MerchantAppUser';
  /** Email */
  email: Scalars['String'];
  /** Fetches a merchant given its ID */
  merchant?: Maybe<Merchant>;
  /** Merchants the current user is authorized to access */
  merchants: MerchantConnection;
};


/** Merchant app viewer information. */
export type MerchantAppUserMerchantArgs = {
  id: Scalars['ID'];
};


/** Merchant app viewer information. */
export type MerchantAppUserMerchantsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Error indicating that a mutation failed because the merchant is closed at the requested time. */
export type MerchantClosureError = Error & {
  __typename?: 'MerchantClosureError';
  /** A description of the error. */
  message: Scalars['String'];
};

export type MerchantClosureInterval = AvailabilityInterval & {
  __typename?: 'MerchantClosureInterval';
  /** Lower bound. */
  lowerBound: Scalars['ISO8601DateTime'];
  /** Upper bound. */
  upperBound: Scalars['ISO8601DateTime'];
};

/** The connection type for Merchant. */
export type MerchantConnection = {
  __typename?: 'MerchantConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MerchantEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Merchant>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type MerchantEdge = {
  __typename?: 'MerchantEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Merchant>;
};

/** Error indicating that a mutation failed because the merchant is not active. */
export type MerchantNotActive = Error & {
  __typename?: 'MerchantNotActive';
  /** A description of the error. */
  message: Scalars['String'];
};

/** Merchant operating status info. */
export type MerchantOperatingStatus = {
  __typename?: 'MerchantOperatingStatus';
  /** Most-recently saved status. */
  lastSavedStatus: MerchantStatusEnum;
  /** Next closing time. */
  nextClose?: Maybe<Scalars['ISO8601DateTime']>;
  /** Next opening time. */
  nextOpen?: Maybe<Scalars['ISO8601DateTime']>;
};

/** Merchant mutation result. */
export type MerchantResult = ErrorsResult | MerchantSuccess;

/** The possible states a merchant's status can return */
export enum MerchantStatusEnum {
  /** Busy. */
  Busy = 'busy',
  /** Closed. */
  Closed = 'closed',
  /** Open. */
  Open = 'open'
}

/** Result of a successful merchant mutation. */
export type MerchantSuccess = {
  __typename?: 'MerchantSuccess';
  /** Resulting merchant. */
  merchant: Merchant;
};

/** Error indicating that a modifier group's minimum/maximum selection bounds were violated. */
export type ModifierBoundsViolation = Error & {
  __typename?: 'ModifierBoundsViolation';
  /** MenuItemModifierGroup. */
  menuItemModifierGroup: MenuItemModifierGroup;
  /** A description of the error. */
  message: Scalars['String'];
};

/** Modifier Group. */
export type ModifierGroup = {
  __typename?: 'ModifierGroup';
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID'];
  /** Modifier Group's current lock version, providing concurrency control and protection against stale updates. */
  lockVersion: Scalars['Int'];
  modifierOptions: Array<ModifierOption>;
  name: Scalars['String'];
  sortOrder: Scalars['Int'];
  /** Visibility. */
  visibility: Visibility;
};

/** Modifier Group mutation result. */
export type ModifierGroupResult = ErrorsResult | ModifierGroupSuccess;

/** Result of a successful modifier group mutation. */
export type ModifierGroupSuccess = {
  __typename?: 'ModifierGroupSuccess';
  /** Resulting modifier group. */
  modifierGroup: ModifierGroup;
};

/** Result of mutating a list of modifier-groups. */
export type ModifierGroupsResult = ErrorsResult | ModifierGroupsSuccess;

/** Result of successfully mutating a list of modifier groups. */
export type ModifierGroupsSuccess = {
  __typename?: 'ModifierGroupsSuccess';
  /** Resulting modifier groups. */
  modifierGroups: Array<ModifierGroup>;
};

/** Modifier Group individual options. */
export type ModifierOption = {
  __typename?: 'ModifierOption';
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID'];
  /** Modifier Option's current lock version, providing concurrency control and protection against stale updates. */
  lockVersion: Scalars['Int'];
  name: Scalars['String'];
  sortOrder: Scalars['Int'];
  /** Visibility. */
  visibility: Visibility;
};

/** Modifier Option mutation result. */
export type ModifierOptionResult = ErrorsResult | ModifierOptionSuccess;

/** Result of a successful modifier option mutation. */
export type ModifierOptionSuccess = {
  __typename?: 'ModifierOptionSuccess';
  /** Resulting modifier option. */
  modifierOption: ModifierOption;
};

/** Result of mutating a list of modifier-options. */
export type ModifierOptionsResult = ErrorsResult | ModifierOptionsSuccess;

/** Result of successfully mutating a list of modifier options. */
export type ModifierOptionsSuccess = {
  __typename?: 'ModifierOptionsSuccess';
  /** Resulting modifier options. */
  modifierOptions: Array<ModifierOption>;
};

export type Money = {
  __typename?: 'Money';
  cents: Scalars['Int'];
  currency: Currency;
};

export type MoneyInput = {
  cents: Scalars['Int'];
  currency?: InputMaybe<Scalars['String']>;
  currencyISO?: InputMaybe<Scalars['String']>;
};

/**
 * Error indicating that a mutation failed because cart prices need to be
 * recalculated. This can occur when attempting to checkout with a different
 * payment method than was used during the last price calculation (since payment
 * method can affect service fees), or if an item or modifier has changed price
 * since being added to the cart.
 */
export type MustRecalculateCartPrices = Error & {
  __typename?: 'MustRecalculateCartPrices';
  /** A description of the error. */
  message: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Acknowledge a consumer order */
  acknowledgeConsumerOrder?: Maybe<AcknowledgeConsumerOrderPayload>;
  /** Add a favorite consumer order. */
  addFavoriteConsumerOrder?: Maybe<AddFavoriteConsumerOrderPayload>;
  /** Add items to cart. */
  addItemsToCart?: Maybe<AddItemsToCartPayload>;
  /** Apply a reward. */
  applyReward?: Maybe<ApplyRewardPayload>;
  attachmentUrlPresigner?: Maybe<AttachmentUrlPresignerCreatePayload>;
  /** Process checkout */
  checkout?: Maybe<CheckoutPayload>;
  /** Claim reward. */
  claimReward?: Maybe<ClaimRewardPayload>;
  /** Mark a consumer order complete */
  consumerOrderComplete?: Maybe<ConsumerOrderCompletePayload>;
  /** Mark a consumer order picked-up */
  consumerOrderPickedUp?: Maybe<ConsumerOrderPickedUpPayload>;
  /** Mark a consumer order ready */
  consumerOrderReady?: Maybe<ConsumerOrderReadyPayload>;
  /** Add attachment to a delivery route stop */
  createDeliveryRouteStopAttachment?: Maybe<DeliveryRouteStopAttachmentCreatePayload>;
  createDriverVisitImage?: Maybe<CreateDriverVisitImageMutationPayload>;
  createFulfillmentIssue?: Maybe<CreateFulfillmentIssueMutationPayload>;
  /** Create a full refund for a consumer order */
  createFullConsumerRefund?: Maybe<CreateFullConsumerRefundPayload>;
  createInventoryItem?: Maybe<SupplyItem>;
  createNonInventoryItem?: Maybe<SupplyItem>;
  /** Create a partial refund for a consumer order */
  createPartialConsumerRefund?: Maybe<CreatePartialConsumerRefundPayload>;
  /** Creates a delivery route for a warehouse */
  createWarehouseDeliveryRoute?: Maybe<DeliveryRouteCreatePayload>;
  /** Removes a delivery issue for a delivery route stop */
  deleteDeliveryIssue?: Maybe<DeliveryIssueDeletePayload>;
  /** Delete delivery route stop attachment */
  deleteDeliveryRouteStopAttachment?: Maybe<DeliveryRouteStopAttachmentDeletePayload>;
  deleteDriverVisitImage?: Maybe<DeleteDriverVisitImageMutationPayload>;
  deleteDriverVisitPhoto?: Maybe<DeleteDriverVisitPhotoMutationPayload>;
  /** Delete Square card. */
  deleteSquareCard?: Maybe<DeleteSquareCardPayload>;
  deleteZipcode?: Maybe<DeleteZipcodeMutationPayload>;
  /** Mark a delivery as completed for a delivery route stop */
  deliveryCompleted?: Maybe<DeliveryCompletedUpdatePayload>;
  /**
   * Update the sequence numbers of a routes delivery stops. This is typically used
   * when users want to change the order of the stops on their delivey route.
   */
  deliveryStopsReorder?: Maybe<DeliveryStopsReorderPayload>;
  discardFulfillmentIssue?: Maybe<DiscardFulfillmentIssueMutationPayload>;
  generatePresignedS3Url?: Maybe<GeneratePresignedUrlMutationPayload>;
  /** Login consumer app user using a Firebase ID. */
  loginConsumerAppUserFromFirebase?: Maybe<LoginConsumerAppUserFromFirebasePayload>;
  /** Marks a delivery as having donation collected and sets a timestamp */
  markCompostCollected?: Maybe<DeliveryRouteStopCompostCollectedUpdatePayload>;
  /** Marks a delivery as having donation collected and sets a timestamp */
  markDonationCollected?: Maybe<DeliveryRouteStopDonationCollectedUpdatePayload>;
  /** Marks an order as delivered */
  markOrderDelivered?: Maybe<OrderDeliveredUpdatePayload>;
  /** Move delivery stops from their current routes to specified route and update associated Vendor pick ups accordingly  */
  moveDeliveryStopsToRoute?: Maybe<DeliveryStopsMoveToRoutePayload>;
  /** Marks an order as collected/fulfilled */
  orderCollected?: Maybe<OrderCollectedUpdatePayload>;
  pricingServicePingify: PricingServicePingifyPayload;
  /** Rebuild the cart from a past order. */
  rebuildCartFromPastOrder?: Maybe<RebuildCartFromPastOrderPayload>;
  /**
   * Recalculate cart prices appropriately for a specific payment method (which can
   * affect fees), using up-to-date menu prices. Items and/or modifiers whose
   * prices have changed since being added to the cart will reflect latest price info.
   */
  recalculateCartPrices?: Maybe<RecalculateCartPricesPayload>;
  /** Empty the cart. */
  removeAllFromCart?: Maybe<RemoveAllFromCartPayload>;
  /** Remove a favorite consumer order. */
  removeFavoriteConsumerOrder?: Maybe<RemoveFavoriteConsumerOrderPayload>;
  /** Remove items from cart. */
  removeItemsFromCart?: Maybe<RemoveItemsFromCartPayload>;
  /** Remove reward. */
  removeReward?: Maybe<RemoveRewardPayload>;
  /** Reports a delivery issue for a delivery route stop */
  reportDeliveryIssue?: Maybe<DeliveryIssueCreatePayload>;
  /** Report phone number verification code. */
  reportPhoneNumberVerification?: Maybe<ReportPhoneNumberVerificationPayload>;
  setServiceTaskGroupNote?: Maybe<SetServiceTaskGroupNoteMutationPayload>;
  /** Set tip. */
  setTip?: Maybe<SetTipPayload>;
  /** Start phone number verification. */
  startPhoneNumberVerification?: Maybe<StartPhoneNumberVerificationPayload>;
  toggleExitDone?: Maybe<ToggleExitDoneMutationPayload>;
  toggleServiceTaskDone?: Maybe<ToggleServiceTaskDoneMutationPayload>;
  /** Updates viewed_at time stamp for a delivery route stop */
  touchDeliveryRouteStop?: Maybe<DeliveryRouteStopViewedAtUpdatePayload>;
  touchDriverVisit?: Maybe<TouchDriverVisitMutationPayload>;
  /** Update the selected size/quantity/note/modifiers on specific cart items. */
  updateCartItems?: Maybe<UpdateCartItemsPayload>;
  /** Update app config */
  updateConfig?: Maybe<UpdateConfigPayload>;
  /** Update current consumer app user. */
  updateCurrentConsumerAppUser?: Maybe<UpdateCurrentConsumerAppUserPayload>;
  /** Update current consumer app user phone number. */
  updateCurrentConsumerAppUserPhoneNumber?: Maybe<UpdateCurrentConsumerAppUserPhoneNumberPayload>;
  /** Update a delivery issue for a delivery route stop */
  updateDeliveryIssue?: Maybe<DeliveryIssueUpdatePayload>;
  updateFulfillmentIssue?: Maybe<UpdateFulfillmentIssueMutationPayload>;
  updateInventoryItem?: Maybe<SupplyItem>;
  updateItemPrices: UpdateItemPricesPayload;
  /** Update a menu-item's saved visibility */
  updateMenuItemSavedVisibility?: Maybe<UpdateMenuItemSavedVisibilityPayload>;
  /** Update menu-items sort order */
  updateMenuItemsSortOrder?: Maybe<UpdateMenuItemsSortOrderPayload>;
  /** Update a menu's saved visibility */
  updateMenuSavedVisibility?: Maybe<UpdateMenuSavedVisibilityPayload>;
  /** Update menus sort order */
  updateMenusSortOrder?: Maybe<UpdateMenusSortOrderPayload>;
  /** Update merchant curbsidePickup */
  updateMerchantCurbsidePickup?: Maybe<UpdateMerchantCurbsidePickupPayload>;
  /** Update the notification sound used by merchant app */
  updateMerchantNotificationSound?: Maybe<UpdateMerchantNotificationSoundPayload>;
  /** Update merchant pickupText */
  updateMerchantPickupText?: Maybe<UpdateMerchantPickupTextPayload>;
  /** Update merchant status */
  updateMerchantStatus?: Maybe<UpdateMerchantStatusPayload>;
  /** Update a modifier group saved visibility */
  updateModifierGroupSavedVisibility?: Maybe<UpdateModifierGroupSavedVisibilityPayload>;
  /** Update modifier-groups sort order */
  updateModifierGroupsSortOrder?: Maybe<UpdateModifierGroupsSortOrderPayload>;
  /** Update a modifier option saved visibility */
  updateModifierOptionSavedVisibility?: Maybe<UpdateModifierOptionSavedVisibilityPayload>;
  /** Update modifier-options sort order */
  updateModifierOptionsSortOrder?: Maybe<UpdateModifierOptionsSortOrderPayload>;
  updateNonInventoryItem?: Maybe<SupplyItem>;
  /** Add or update warehouse note for an order */
  updateOrderWarehouseNote?: Maybe<OrderWarehouseNoteUpdatePayload>;
  /** Assigns driver to a route */
  updateRouteDetails?: Maybe<RouteDetailsUpdatePayload>;
  /** Add or update route stop driver reminder message */
  updateRouteStopDriverReminder?: Maybe<DeliveryRouteStopReminderUpdatePayload>;
  updateServiceTaskOrder?: Maybe<UpdateServiceTaskOrderMutationPayload>;
  /** Update a submenu's saved visibility */
  updateSubmenuSavedVisibility?: Maybe<UpdateSubmenuSavedVisibilityPayload>;
  /** Update submenus sort order */
  updateSubmenusSortOrder?: Maybe<UpdateSubmenusSortOrderPayload>;
  updateVendorTask?: Maybe<UpdateVendorTaskMutationPayload>;
  upsertWarehouseZipcodes?: Maybe<UpsertWarehouseZipcodesPayload>;
};


export type MutationAcknowledgeConsumerOrderArgs = {
  input: AcknowledgeConsumerOrderInput;
};


export type MutationAddFavoriteConsumerOrderArgs = {
  input: AddFavoriteConsumerOrderInput;
};


export type MutationAddItemsToCartArgs = {
  input: AddItemsToCartInput;
};


export type MutationApplyRewardArgs = {
  input: ApplyRewardInput;
};


export type MutationAttachmentUrlPresignerArgs = {
  input: AttachmentUrlPresignerCreateInput;
};


export type MutationCheckoutArgs = {
  input: CheckoutInput;
};


export type MutationClaimRewardArgs = {
  input: ClaimRewardInput;
};


export type MutationConsumerOrderCompleteArgs = {
  input: ConsumerOrderCompleteInput;
};


export type MutationConsumerOrderPickedUpArgs = {
  input: ConsumerOrderPickedUpInput;
};


export type MutationConsumerOrderReadyArgs = {
  input: ConsumerOrderReadyInput;
};


export type MutationCreateDeliveryRouteStopAttachmentArgs = {
  input: DeliveryRouteStopAttachmentCreateInput;
};


export type MutationCreateDriverVisitImageArgs = {
  input: CreateDriverVisitImageMutationInput;
};


export type MutationCreateFulfillmentIssueArgs = {
  input: CreateFulfillmentIssueMutationInput;
};


export type MutationCreateFullConsumerRefundArgs = {
  input: CreateFullConsumerRefundInput;
};


export type MutationCreateInventoryItemArgs = {
  item: InventoryItemInput;
};


export type MutationCreateNonInventoryItemArgs = {
  item: NonInventoryItemInput;
};


export type MutationCreatePartialConsumerRefundArgs = {
  input: CreatePartialConsumerRefundInput;
};


export type MutationCreateWarehouseDeliveryRouteArgs = {
  input: DeliveryRouteCreateInput;
};


export type MutationDeleteDeliveryIssueArgs = {
  input: DeliveryIssueDeleteInput;
};


export type MutationDeleteDeliveryRouteStopAttachmentArgs = {
  input: DeliveryRouteStopAttachmentDeleteInput;
};


export type MutationDeleteDriverVisitImageArgs = {
  input: DeleteDriverVisitImageMutationInput;
};


export type MutationDeleteDriverVisitPhotoArgs = {
  input: DeleteDriverVisitPhotoMutationInput;
};


export type MutationDeleteSquareCardArgs = {
  input: DeleteSquareCardInput;
};


export type MutationDeleteZipcodeArgs = {
  input: DeleteZipcodeMutationInput;
};


export type MutationDeliveryCompletedArgs = {
  input: DeliveryCompletedUpdateInput;
};


export type MutationDeliveryStopsReorderArgs = {
  input: DeliveryStopsReorderInput;
};


export type MutationDiscardFulfillmentIssueArgs = {
  input: DiscardFulfillmentIssueMutationInput;
};


export type MutationGeneratePresignedS3UrlArgs = {
  input: GeneratePresignedUrlMutationInput;
};


export type MutationLoginConsumerAppUserFromFirebaseArgs = {
  input: LoginConsumerAppUserFromFirebaseInput;
};


export type MutationMarkCompostCollectedArgs = {
  input: DeliveryRouteStopCompostCollectedUpdateInput;
};


export type MutationMarkDonationCollectedArgs = {
  input: DeliveryRouteStopDonationCollectedUpdateInput;
};


export type MutationMarkOrderDeliveredArgs = {
  input: OrderDeliveredUpdateInput;
};


export type MutationMoveDeliveryStopsToRouteArgs = {
  input: DeliveryStopsMoveToRouteInput;
};


export type MutationOrderCollectedArgs = {
  input: OrderCollectedUpdateInput;
};


export type MutationPricingServicePingifyArgs = {
  input: PricingServicePingifyInput;
};


export type MutationRebuildCartFromPastOrderArgs = {
  input: RebuildCartFromPastOrderInput;
};


export type MutationRecalculateCartPricesArgs = {
  input: RecalculateCartPricesInput;
};


export type MutationRemoveAllFromCartArgs = {
  input: RemoveAllFromCartInput;
};


export type MutationRemoveFavoriteConsumerOrderArgs = {
  input: RemoveFavoriteConsumerOrderInput;
};


export type MutationRemoveItemsFromCartArgs = {
  input: RemoveItemsFromCartInput;
};


export type MutationRemoveRewardArgs = {
  input: RemoveRewardInput;
};


export type MutationReportDeliveryIssueArgs = {
  input: DeliveryIssueCreateInput;
};


export type MutationReportPhoneNumberVerificationArgs = {
  input: ReportPhoneNumberVerificationInput;
};


export type MutationSetServiceTaskGroupNoteArgs = {
  input: SetServiceTaskGroupNoteMutationInput;
};


export type MutationSetTipArgs = {
  input: SetTipInput;
};


export type MutationStartPhoneNumberVerificationArgs = {
  input: StartPhoneNumberVerificationInput;
};


export type MutationToggleExitDoneArgs = {
  input: ToggleExitDoneMutationInput;
};


export type MutationToggleServiceTaskDoneArgs = {
  input: ToggleServiceTaskDoneMutationInput;
};


export type MutationTouchDeliveryRouteStopArgs = {
  input: DeliveryRouteStopViewedAtUpdateInput;
};


export type MutationTouchDriverVisitArgs = {
  input: TouchDriverVisitMutationInput;
};


export type MutationUpdateCartItemsArgs = {
  input: UpdateCartItemsInput;
};


export type MutationUpdateConfigArgs = {
  input: UpdateConfigInput;
};


export type MutationUpdateCurrentConsumerAppUserArgs = {
  input: UpdateCurrentConsumerAppUserInput;
};


export type MutationUpdateCurrentConsumerAppUserPhoneNumberArgs = {
  input: UpdateCurrentConsumerAppUserPhoneNumberInput;
};


export type MutationUpdateDeliveryIssueArgs = {
  input: DeliveryIssueUpdateInput;
};


export type MutationUpdateFulfillmentIssueArgs = {
  input: UpdateFulfillmentIssueMutationInput;
};


export type MutationUpdateInventoryItemArgs = {
  id: Scalars['ID'];
  item: InventoryItemInput;
};


export type MutationUpdateItemPricesArgs = {
  input: UpdateItemPricesInput;
};


export type MutationUpdateMenuItemSavedVisibilityArgs = {
  input: UpdateMenuItemSavedVisibilityInput;
};


export type MutationUpdateMenuItemsSortOrderArgs = {
  input: UpdateMenuItemsSortOrderInput;
};


export type MutationUpdateMenuSavedVisibilityArgs = {
  input: UpdateMenuSavedVisibilityInput;
};


export type MutationUpdateMenusSortOrderArgs = {
  input: UpdateMenusSortOrderInput;
};


export type MutationUpdateMerchantCurbsidePickupArgs = {
  input: UpdateMerchantCurbsidePickupInput;
};


export type MutationUpdateMerchantNotificationSoundArgs = {
  input: UpdateMerchantNotificationSoundInput;
};


export type MutationUpdateMerchantPickupTextArgs = {
  input: UpdateMerchantPickupTextInput;
};


export type MutationUpdateMerchantStatusArgs = {
  input: UpdateMerchantStatusInput;
};


export type MutationUpdateModifierGroupSavedVisibilityArgs = {
  input: UpdateModifierGroupSavedVisibilityInput;
};


export type MutationUpdateModifierGroupsSortOrderArgs = {
  input: UpdateModifierGroupsSortOrderInput;
};


export type MutationUpdateModifierOptionSavedVisibilityArgs = {
  input: UpdateModifierOptionSavedVisibilityInput;
};


export type MutationUpdateModifierOptionsSortOrderArgs = {
  input: UpdateModifierOptionsSortOrderInput;
};


export type MutationUpdateNonInventoryItemArgs = {
  id: Scalars['ID'];
  item: NonInventoryItemInput;
};


export type MutationUpdateOrderWarehouseNoteArgs = {
  input: OrderWarehouseNoteUpdateInput;
};


export type MutationUpdateRouteDetailsArgs = {
  input: RouteDetailsUpdateInput;
};


export type MutationUpdateRouteStopDriverReminderArgs = {
  input: DeliveryRouteStopReminderUpdateInput;
};


export type MutationUpdateServiceTaskOrderArgs = {
  input: UpdateServiceTaskOrderMutationInput;
};


export type MutationUpdateSubmenuSavedVisibilityArgs = {
  input: UpdateSubmenuSavedVisibilityInput;
};


export type MutationUpdateSubmenusSortOrderArgs = {
  input: UpdateSubmenusSortOrderInput;
};


export type MutationUpdateVendorTaskArgs = {
  input: UpdateVendorTaskMutationInput;
};


export type MutationUpsertWarehouseZipcodesArgs = {
  input: UpsertWarehouseZipcodesInput;
};

export type NetsuiteTransaction = {
  __typename?: 'NetsuiteTransaction';
  createdAt?: Maybe<Scalars['ISO8601Date']>;
  date?: Maybe<Scalars['ISO8601Date']>;
  id: Scalars['ID'];
  location?: Maybe<Location>;
  order?: Maybe<Order>;
  pdfS3Key?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  totalPriceCents?: Maybe<Scalars['String']>;
  transactionType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['ISO8601Date']>;
  vendor?: Maybe<Vendor>;
};

/** An object with an ID. */
export type Node = {
  /** ID of the object. */
  id: Scalars['ID'];
};

/**
 * A NonInventoryItem is an item we pick up from vendors to deliver.
 * Their relationship with a Warehouse is as follows:
 * A warehouse dispatches a driver to pick up and deliver non-inventory items from
 * a vendor.
 */
export type NonInventoryItem = SupplyItem & {
  __typename?: 'NonInventoryItem';
  brandName: Scalars['String'];
  /** (Package Height x Package Width x Package Length)/DIM factor */
  caseDimensionalWeightLbs?: Maybe<Scalars['Float']>;
  caseHeightInches?: Maybe<Scalars['Float']>;
  caseLengthInches?: Maybe<Scalars['Float']>;
  caseVolumeCuInches?: Maybe<Scalars['Float']>;
  caseWeightLbs?: Maybe<Scalars['Float']>;
  caseWidthInches?: Maybe<Scalars['Float']>;
  catalogStatus: CatalogStatus;
  category: Category;
  createdAt: Scalars['ISO8601DateTime'];
  createdBy: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  /**
   * Drives pricing with carriers like FedEx.
   * This data is uploaded from Cubiscan dimensioning device to optimize shipping costs.
   */
  dimensionalFactor?: Maybe<Scalars['Float']>;
  /** (Package Height x Package Width x Package Length)/DIM factor */
  eachDimensionalWeightLbs?: Maybe<Scalars['Float']>;
  eachHeightInches?: Maybe<Scalars['Float']>;
  eachLengthInches?: Maybe<Scalars['Float']>;
  eachVolumeCuInches?: Maybe<Scalars['Float']>;
  eachWeightLbs?: Maybe<Scalars['Float']>;
  eachWidthInches?: Maybe<Scalars['Float']>;
  erpPlatform?: Maybe<ErpPlatform>;
  erpRecordId?: Maybe<Scalars['ID']>;
  erpRecordType?: Maybe<ErpRecord>;
  erpRecordUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imgUrl?: Maybe<Scalars['String']>;
  itemLocationsCustomPrice?: Maybe<Array<ItemLocationCustomPrice>>;
  itemSize?: Maybe<Scalars['String']>;
  minItemsPerOrder?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  purchaseMultiple: Scalars['Int'];
  purchasePrice: Money;
  refrigerationState?: Maybe<RefrigerationState>;
  saleUnit: Unit;
  sampleUnit?: Maybe<Unit>;
  standingOrderBehavior: StandingOrderBehavior;
  subcategory?: Maybe<Category>;
  transitMethod?: Maybe<TransitMethod>;
  updatedAt: Scalars['ISO8601DateTime'];
  updatedBy: Scalars['String'];
  vendorCode?: Maybe<Scalars['String']>;
  warehouseAssociation?: Maybe<Array<Maybe<NonInventoryWarehouseAssociation>>>;
};


/**
 * A NonInventoryItem is an item we pick up from vendors to deliver.
 * Their relationship with a Warehouse is as follows:
 * A warehouse dispatches a driver to pick up and deliver non-inventory items from
 * a vendor.
 */
export type NonInventoryItemWarehouseAssociationArgs = {
  warehouseIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type NonInventoryItemInput = {
  brandName: Scalars['String'];
  caseHeightInches?: InputMaybe<Scalars['Float']>;
  caseLengthInches?: InputMaybe<Scalars['Float']>;
  caseWeightLbs?: InputMaybe<Scalars['Float']>;
  caseWidthInches?: InputMaybe<Scalars['Float']>;
  catalogStatus: CatalogStatus;
  category: Scalars['ID'];
  description?: InputMaybe<Scalars['String']>;
  dimensionalFactor?: InputMaybe<Scalars['Float']>;
  eachHeightInches?: InputMaybe<Scalars['Float']>;
  eachLengthInches?: InputMaybe<Scalars['Float']>;
  eachWeightLbs?: InputMaybe<Scalars['Float']>;
  eachWidthInches?: InputMaybe<Scalars['Float']>;
  imgUrl?: InputMaybe<Scalars['String']>;
  itemSize?: InputMaybe<Scalars['String']>;
  minItemsPerOrder?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  purchaseMultiple: Scalars['Int'];
  purchasePrice: MoneyInput;
  refrigerationState?: InputMaybe<RefrigerationState>;
  saleUnit: Scalars['ID'];
  sampleUnit?: InputMaybe<Scalars['ID']>;
  standingOrderBehavior: StandingOrderBehavior;
  subcategory?: InputMaybe<Scalars['ID']>;
  transitMethod?: InputMaybe<TransitMethod>;
  vendorCode?: InputMaybe<Scalars['String']>;
  warehouseAssociation?: InputMaybe<Array<InputMaybe<NonInventoryWarehouseAssociationInput>>>;
};

/**
 * NonInventory items are picked up from vendors while out on delivery.
 * A driver is *dispatched* from a warehouse to pick up and deliver the item.
 */
export type NonInventoryWarehouseAssociation = {
  __typename?: 'NonInventoryWarehouseAssociation';
  hasSample?: Maybe<Scalars['Boolean']>;
  item: NonInventoryItem;
  landedCost?: Maybe<Money>;
  salePrice?: Maybe<Money>;
  sample?: Maybe<SupplyItem>;
  vendor?: Maybe<Vendor>;
  warehouse: Warehouse;
};

export type NonInventoryWarehouseAssociationInput = {
  hasSample?: InputMaybe<Scalars['Boolean']>;
  salePrice: MoneyInput;
  vendorId: Scalars['ID'];
  warehouseId: Scalars['ID'];
};

/** Error indicating that a mutation failed because the requested pickup time did not satisfy merchant's minimum notice. */
export type NotEnoughNotice = Error & {
  __typename?: 'NotEnoughNotice';
  /** A description of the error. */
  message: Scalars['String'];
  /** Minimum notice an order can be placed in advance of its pickup time. */
  minimumNotice: RelativeTime;
};

/** Error indicating a partial refund was attempted without specifying any items or modifiers to refund. */
export type NothingToRefund = Error & {
  __typename?: 'NothingToRefund';
  /** A description of the error. */
  message: Scalars['String'];
};

/**
 * Error indicating that a mutation failed because its inputs included an object
 * from a collection other than the expected collection.
 */
export type ObjectFromOutsideCollection = Error & {
  __typename?: 'ObjectFromOutsideCollection';
  /** ID of the object. */
  id: Scalars['ID'];
  /** A description of the error. */
  message: Scalars['String'];
};

/** Error indicating that an object could not be found with the ID provided by an input argument. */
export type ObjectNotFound = Error & {
  __typename?: 'ObjectNotFound';
  /** ID that caused the error. */
  id: Scalars['ID'];
  /** A description of the error. */
  message: Scalars['String'];
};

/** Error indicating that mutation failed to save an object. */
export type ObjectNotSaved = Error & {
  __typename?: 'ObjectNotSaved';
  /** ID of the object that failed to save. */
  id?: Maybe<Scalars['ID']>;
  /** A description of the error. */
  message: Scalars['String'];
};

/**
 * Error indicating that a mutation whose input requires a complete collection
 * failed because an object was omitted from the collection.
 */
export type ObjectOmittedFromCollection = Error & {
  __typename?: 'ObjectOmittedFromCollection';
  /** ID of the omitted object. */
  id: Scalars['ID'];
  /** A description of the error. */
  message: Scalars['String'];
};

export type OperatingHoursBound = {
  __typename?: 'OperatingHoursBound';
  /** Day of week. */
  dayOfWeek: DayOfWeekEnum;
  /** Time of day in HH:MM:SS format. */
  timeOfDay: Scalars['String'];
};

export type OperatingHoursForDayOfWeek = {
  __typename?: 'OperatingHoursForDayOfWeek';
  /** Operating hours intervals. May spill over into a subsequent day. */
  intervals: Array<OperatingHoursInterval>;
  /** Operating day of week. */
  operatingDay: DayOfWeekEnum;
};

export type OperatingHoursInterval = {
  __typename?: 'OperatingHoursInterval';
  /** Lower bound. */
  lowerBound: OperatingHoursBound;
  /** Upper bound. */
  upperBound: OperatingHoursBound;
};

export type Order = {
  __typename?: 'Order';
  collectedAt?: Maybe<Scalars['ISO8601DateTime']>;
  deliveredAt?: Maybe<Scalars['ISO8601DateTime']>;
  erpPlatform?: Maybe<ErpPlatform>;
  erpRecordId?: Maybe<Scalars['ID']>;
  erpRecordType?: Maybe<ErpRecord>;
  erpRecordUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  issues?: Maybe<Array<Issue>>;
  location: Location;
  orderLines: Array<OrderLine>;
  totalItemQuantity: Scalars['Int'];
  vendor: Vendor;
  warehouseNote?: Maybe<Scalars['String']>;
};

/** Accepted orderBy values */
export enum OrderByEnum {
  /** Ascending, nulls last */
  Asc = 'asc',
  /** Descending, nulls first */
  Desc = 'desc'
}

/** Autogenerated input type of OrderCollectedUpdate */
export type OrderCollectedUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Denotes if the order was collected */
  collected: Scalars['Boolean'];
  /** Order id. */
  orderId: Scalars['ID'];
};

/** Autogenerated return type of OrderCollectedUpdate */
export type OrderCollectedUpdatePayload = {
  __typename?: 'OrderCollectedUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  userErrors: Array<OrderError>;
};

/** Autogenerated input type of OrderDeliveredUpdate */
export type OrderDeliveredUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Denotes if the order was delivered */
  delivered: Scalars['Boolean'];
  /** Order id. */
  orderId: Scalars['ID'];
};

/** Autogenerated return type of OrderDeliveredUpdate */
export type OrderDeliveredUpdatePayload = {
  __typename?: 'OrderDeliveredUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  userErrors: Array<OrderError>;
};

/** Order possible error types */
export type OrderError = OrderNotFound;

export type OrderFulfillmentServiceTask = ServiceTask & {
  __typename?: 'OrderFulfillmentServiceTask';
  fulfilledAt?: Maybe<Scalars['ISO8601DateTime']>;
  fulfillmentIssues: Array<FulfillmentIssue>;
  id: Scalars['ID'];
  serviceTaskMessage?: Maybe<ServiceTaskMessage>;
  serviceTaskOrder: ServiceTaskOrder;
  taskType: Task;
};

export type OrderFulfillmentVendorTask = VendorTask & {
  __typename?: 'OrderFulfillmentVendorTask';
  fulfilledAt?: Maybe<Scalars['ISO8601DateTime']>;
  fulfillmentIssues: Array<FulfillmentIssue>;
  id: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  serviceTaskOrder: ServiceTaskOrder;
  taskType: CafeAction;
  vendorVisit: VendorVisit;
};

export type OrderLine = {
  __typename?: 'OrderLine';
  costPerItemCents: Scalars['Float'];
  fractional: Scalars['Boolean'];
  id: Scalars['ID'];
  itemsPerLot: Scalars['Int'];
  order: Order;
  orderUnitQuantity: Scalars['Int'];
  quantity: Scalars['Int'];
  quantityType: Scalars['String'];
  sku: Sku;
  totalQuantity: Scalars['Int'];
  unitCostCents: Scalars['Float'];
};

export type OrderNotFound = BusinessError & {
  __typename?: 'OrderNotFound';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

/** Error indicating that a mutation failed because a free order cannot be created with a non-zero total. */
export type OrderNotFree = Error & {
  __typename?: 'OrderNotFree';
  /** A description of the error. */
  message: Scalars['String'];
};

export type OrderQueue = {
  __typename?: 'OrderQueue';
  /** Orders that need to be prepared for imminent pickup. */
  current: ConsumerOrderConnection;
  /** Order history. */
  history: ConsumerOrderConnection;
  /** Orders that need to be prepared, but not immediately. */
  scheduled: ConsumerOrderConnection;
};


export type OrderQueueCurrentArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ConsumerOrderSortCriteria>;
};


export type OrderQueueHistoryArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ConsumerOrderSortCriteria>;
};


export type OrderQueueScheduledArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ConsumerOrderSortCriteria>;
};

/** Autogenerated input type of OrderWarehouseNoteUpdate */
export type OrderWarehouseNoteUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Warehouse note for the order */
  note: Scalars['String'];
  /** order id. */
  orderId: Scalars['ID'];
};

/** Autogenerated return type of OrderWarehouseNoteUpdate */
export type OrderWarehouseNoteUpdatePayload = {
  __typename?: 'OrderWarehouseNoteUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  order?: Maybe<Order>;
  userErrors: Array<OrderError>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Payment method values. */
export enum PaymentMethod {
  /** Free. */
  Free = 'free',
  /** Square card ID. */
  SquareCardId = 'square_card_id',
  /** Square card nonce. */
  SquareCardNonce = 'square_card_nonce',
  /** Wallet balance. */
  WalletBalance = 'wallet_balance'
}

/** Error indicating that a mutation failed due to a payment processor error whose cause is unknown. */
export type PaymentProcessorGenericError = Error & {
  __typename?: 'PaymentProcessorGenericError';
  /** A description of the error. */
  message: Scalars['String'];
};

export enum Perishability {
  NonPerishable = 'NON_PERISHABLE',
  Perishable = 'PERISHABLE',
  SemiPerishable = 'SEMI_PERISHABLE'
}

/** Error indicating the requested phone number is already in use. */
export type PhoneNumberAlreadyTaken = Error & {
  __typename?: 'PhoneNumberAlreadyTaken';
  /** A description of the error. */
  message: Scalars['String'];
};

/** Error indicating that a mutation failed because the provided phone number was not formatted correctly. */
export type PhoneNumberNotFormatted = Error & {
  __typename?: 'PhoneNumberNotFormatted';
  /** A description of the error. */
  message: Scalars['String'];
};

/** Error indicating that a mutation failed because the provided phone number was not successfully verified. */
export type PhoneNumberNotVerified = Error & {
  __typename?: 'PhoneNumberNotVerified';
  /** A description of the error. */
  message: Scalars['String'];
};

/** Error indicating a failure to start phone number verification. */
export type PhoneNumberVerificationNotStarted = Error & {
  __typename?: 'PhoneNumberVerificationNotStarted';
  /** A description of the error. */
  message: Scalars['String'];
};

/** Result of successfully starting phone number verification. */
export type PhoneNumberVerificationStarted = {
  __typename?: 'PhoneNumberVerificationStarted';
  /** Success message. */
  message: Scalars['String'];
};

/** Result of successfully reporting phone number verification. */
export type PhoneNumberVerified = {
  __typename?: 'PhoneNumberVerified';
  /**
   * ID of successful phone number verification. This should be included as an
   * argument to mutations that require proof of successful phone number verification.
   */
  phoneVerificationId: Scalars['ID'];
};

export type PickUp = {
  __typename?: 'PickUp';
  attachments?: Maybe<Array<Attachment>>;
  id: Scalars['ID'];
  issues?: Maybe<Array<Issue>>;
  orders?: Maybe<Array<Order>>;
  reminderMessage?: Maybe<Scalars['String']>;
  sequenceNumber?: Maybe<Scalars['String']>;
  vendor: Vendor;
};

export type PickupSchedule = {
  __typename?: 'PickupSchedule';
  /** Time treated as current during schedule calculation. */
  asOf: Scalars['ISO8601DateTime'];
  /** Pickup schedules by date. */
  byDate: Array<PickupScheduleOnDate>;
  /** Server time when schedule was calculated. */
  calculatedAt: Scalars['ISO8601DateTime'];
  /** Default pickup time. This is the earliest available pickup time, or null if no available time was found. */
  defaultPickupTime?: Maybe<PickupTime>;
  /** Minimum notice required for pickup. */
  minimumNotice: RelativeTime;
  /** Time zone of date boundaries. */
  timezone: Scalars['String'];
};

export type PickupScheduleOnDate = {
  __typename?: 'PickupScheduleOnDate';
  /** Time intervals describing availability or reasons for unavailability. */
  allIntervals: Array<AvailabilityInterval>;
  /** Time intervals during which pickup is available. */
  availableIntervals: Array<AvailableInterval>;
  /** Calendar date in schedule's time zone. */
  date: Scalars['ISO8601Date'];
};

/** Pickup time. */
export type PickupTime = AbsoluteTime | RelativeTime;

/** AWS S3 service possible errors */
export type PresignerError = ServiceError;

/** Price correction indicating that a price expectation was out of date or otherwise inaccurate. */
export type PriceCorrection = Error & {
  __typename?: 'PriceCorrection';
  /** Correct price. */
  correctPrice: Money;
  /** ID of object associated with this price correction. */
  id: Scalars['ID'];
  /** A description of the error. */
  message: Scalars['String'];
};

/** Autogenerated input type of PricingServicePingify */
export type PricingServicePingifyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of PricingServicePingify */
export type PricingServicePingifyPayload = {
  __typename?: 'PricingServicePingifyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  result: Scalars['String'];
};

export type ProcurementVendor = {
  __typename?: 'ProcurementVendor';
  /** The procurement vendor UUID */
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ProductInventory = {
  __typename?: 'ProductInventory';
  /**
   * on hand count = amount physically on our shelves in the warehouse
   *
   * available count = on hand count - amount already committed to orders in netsuite = amount available for ordering
   */
  availableCount?: Maybe<Scalars['Int']>;
  warehouse: Warehouse;
};

export type Query = {
  __typename?: 'Query';
  /** Returns a list of active zipcodes matches the passed zipcodes */
  activeZipcodes?: Maybe<Array<Zipcode>>;
  /** List allowance recipients */
  allowanceRecipients: AllowanceRecipientConnection;
  /** List rewards applicable at checkout. */
  applicableRewards: Array<Reward>;
  /** List batched deposits */
  batchedDeposits: BatchedDepositConnection;
  /**
   * Calculate a full consumer refund. This provides a preview of the refund
   * info that would result from executing the createFullConsumerRefund
   * mutation.
   */
  calculateFullConsumerRefund: ConsumerRefundInfoResult;
  /**
   * Calculate a partial consumer refund. This provides a preview of the refund
   * info that would result from executing the createPartialConsumerRefund
   * mutation.
   */
  calculatePartialConsumerRefund: ConsumerRefundInfoResult;
  /** Shopping cart */
  cart: Cart;
  categories: Array<Category>;
  categoryById?: Maybe<Category>;
  categoryByName?: Maybe<Category>;
  /** Get the config that's current as of a given datetime */
  config: Config;
  /** List configs in reverse chronological order */
  configs: ConfigConnection;
  /** Fetches a consumer order by ID */
  consumerOrder?: Maybe<ConsumerOrder>;
  /** Info about consumer post-order survey. */
  consumerPostOrderSurvey?: Maybe<ConsumerPostOrderSurvey>;
  /** Current ConsumerAppUser. Null unless logged into a consumer account. */
  currentConsumerAppUser?: Maybe<ConsumerAppUser>;
  /** Returns a single route */
  deliveryRoute: DeliveryRoute;
  /** Returns a list of driver routes */
  deliveryRoutes: Array<DeliveryRoute>;
  /** Get a driver visit by id */
  driverVisit?: Maybe<DriverVisit>;
  /** Lists favorite consumer orders */
  favoriteConsumerOrders: Array<FavoriteConsumerOrder>;
  /** Get a location by: id , uuid , encrypted id */
  location?: Maybe<Location>;
  /** Fetches a merchant given its ID */
  merchant?: Maybe<Merchant>;
  /** Information about the currently logged-in merchant app viewer. */
  merchantAppViewer: MerchantAppUser;
  /** Fetches a merchant given its databaseId */
  merchantByDatabaseId?: Maybe<Merchant>;
  /** List merchants */
  merchants: MerchantConnection;
  /** Fetches an object given its ID. */
  node?: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  /** Get an order by ID */
  order?: Maybe<Order>;
  /** Pickup schedule for specified merchant and menu items. */
  pickupSchedule: PickupSchedule;
  pricingServicePing: Scalars['String'];
  /** Returns all procurement vendors */
  procurementVendors: Array<ProcurementVendor>;
  /** Returns the current inventory for a product */
  productInventory: Array<ProductInventory>;
  /** Returns a single route */
  route: Route;
  /** Returns all routes for a warehouse */
  routes: Array<Route>;
  signedUploadImageByKey?: Maybe<UploadItemImageByKey>;
  signedUploadImageUrl?: Maybe<UploadItemImage>;
  /** Returns a single stop */
  stop: DeliveryStop;
  unitById?: Maybe<Unit>;
  unitByName?: Maybe<Unit>;
  units: Array<Maybe<Unit>>;
  /** Get a vendor by ID */
  vendor?: Maybe<Vendor>;
  vendorTaskList?: Maybe<VendorTaskList>;
  vendorTaskLists: Array<VendorTaskList>;
  /** Get a vendor visit for a route, vendor, night end */
  vendorVisit?: Maybe<VendorVisit>;
  /** Returns all vendors */
  vendors: Array<Vendor>;
  /** The currently authenticated user. */
  viewer?: Maybe<User>;
  /** Find warehouse by id */
  warehouse: Warehouse;
  /** Returns all warehouses */
  warehouses: Array<Warehouse>;
};


export type QueryActiveZipcodesArgs = {
  zipcodes: Array<Scalars['String']>;
};


export type QueryAllowanceRecipientsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<AllowanceRecipientOrderBy>;
};


export type QueryApplicableRewardsArgs = {
  onDate: Scalars['ISO8601Date'];
};


export type QueryBatchedDepositsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forDateRange?: InputMaybe<DateRangeInput>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<BatchedDepositOrderBy>;
  totalCentsRange?: InputMaybe<IntRangeInput>;
};


export type QueryCalculateFullConsumerRefundArgs = {
  consumerOrderId: Scalars['ID'];
  lockVersion: Scalars['Int'];
};


export type QueryCalculatePartialConsumerRefundArgs = {
  consumerOrderId: Scalars['ID'];
  lockVersion: Scalars['Int'];
  refundItemInputs: Array<ConsumerRefundItemInput>;
  refundModifierInputs: Array<ConsumerRefundModifierInput>;
};


export type QueryCategoriesArgs = {
  filter?: InputMaybe<CategoriesFilter>;
  sortOrder?: InputMaybe<Array<InputMaybe<CategoriesSortOrder>>>;
};


export type QueryCategoryByIdArgs = {
  id: Scalars['ID'];
};


export type QueryCategoryByNameArgs = {
  name: Scalars['String'];
};


export type QueryConfigArgs = {
  asOf?: InputMaybe<Scalars['ISO8601DateTime']>;
};


export type QueryConfigsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ConfigOrderBy>;
};


export type QueryConsumerOrderArgs = {
  id: Scalars['ID'];
};


export type QueryDeliveryRouteArgs = {
  id: Scalars['ID'];
};


export type QueryDeliveryRoutesArgs = {
  queryTime?: InputMaybe<Scalars['ISO8601DateTime']>;
  warehouseId?: InputMaybe<Scalars['ID']>;
};


export type QueryDriverVisitArgs = {
  id: Scalars['ID'];
};


export type QueryLocationArgs = {
  encryptedLocationId?: InputMaybe<Scalars['ID']>;
  locationId?: InputMaybe<Scalars['ID']>;
  odekoUuid?: InputMaybe<Scalars['ID']>;
};


export type QueryMerchantArgs = {
  id: Scalars['ID'];
};


export type QueryMerchantByDatabaseIdArgs = {
  databaseId: Scalars['Int'];
};


export type QueryMerchantsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  business?: InputMaybe<BusinessSearchInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  near?: InputMaybe<GeospatialCircle>;
};


export type QueryNodeArgs = {
  id: Scalars['ID'];
};


export type QueryNodesArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryOrderArgs = {
  orderId: Scalars['ID'];
};


export type QueryPickupScheduleArgs = {
  asOf?: InputMaybe<Scalars['ISO8601DateTime']>;
  menuItemIds: Array<Scalars['ID']>;
  merchantId: Scalars['ID'];
};


export type QueryProductInventoryArgs = {
  productId: Scalars['ID'];
};


export type QueryRouteArgs = {
  input: RouteInput;
};


export type QueryRoutesArgs = {
  input: RoutesInput;
};


export type QuerySignedUploadImageByKeyArgs = {
  key: Scalars['String'];
};


export type QuerySignedUploadImageUrlArgs = {
  extension: Scalars['String'];
};


export type QueryStopArgs = {
  input: StopInput;
};


export type QueryUnitByIdArgs = {
  id: Scalars['ID'];
};


export type QueryUnitByNameArgs = {
  name: Scalars['String'];
};


export type QueryUnitsArgs = {
  sortOrder?: InputMaybe<Array<InputMaybe<UnitSortOrder>>>;
  unitType?: InputMaybe<UnitType>;
};


export type QueryVendorArgs = {
  vendorId: Scalars['ID'];
};


export type QueryVendorTaskListArgs = {
  nightEnd: Scalars['ISO8601Date'];
  vendorId: Scalars['ID'];
};


export type QueryVendorTaskListsArgs = {
  queryTime: Scalars['ISO8601DateTime'];
};


export type QueryVendorVisitArgs = {
  deliveryRouteId: Scalars['ID'];
  nightEnd: Scalars['ISO8601Date'];
  vendorId: Scalars['ID'];
};


export type QueryWarehouseArgs = {
  warehouseId: Scalars['ID'];
};

/** Autogenerated input type of RebuildCartFromPastOrder */
export type RebuildCartFromPastOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Opaque token identifying a specific version of the cart. */
  fingerprint: Scalars['String'];
  /** The order's primary key from the database. */
  orderDatabaseId: Scalars['Int'];
};

/** Autogenerated return type of RebuildCartFromPastOrder */
export type RebuildCartFromPastOrderPayload = {
  __typename?: 'RebuildCartFromPastOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to rebuild cart from past order. */
  result: CartResult;
};

/** Autogenerated input type of RecalculateCartPrices */
export type RecalculateCartPricesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Opaque token identifying a specific version of the cart. */
  fingerprint: Scalars['String'];
  /** Intended payment method. This affects service fee. */
  paymentMethod: PaymentMethod;
};

/** Autogenerated return type of RecalculateCartPrices */
export type RecalculateCartPricesPayload = {
  __typename?: 'RecalculateCartPricesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to set tip. */
  result: CartResult;
};

export enum RefrigerationState {
  Frozen = 'FROZEN',
  Refrigerated = 'REFRIGERATED',
  RoomTemp = 'ROOM_TEMP'
}

/** Error indicating a request attempted to refund too many items. */
export type RefundingTooManyItems = Error & {
  __typename?: 'RefundingTooManyItems';
  /** A description of the error. */
  message: Scalars['String'];
};

/** Error indicating a request attempted to refund too many modifiers. */
export type RefundingTooManyModifiers = Error & {
  __typename?: 'RefundingTooManyModifiers';
  /** A description of the error. */
  message: Scalars['String'];
};

export type RelativeTime = {
  __typename?: 'RelativeTime';
  /** Seconds. */
  seconds: Scalars['Int'];
};

export type RelativeTimeInput = {
  /** Seconds. */
  seconds: Scalars['Int'];
};

/** Autogenerated input type of RemoveAllFromCart */
export type RemoveAllFromCartInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Opaque token identifying a specific version of the cart. */
  fingerprint: Scalars['String'];
};

/** Autogenerated return type of RemoveAllFromCart */
export type RemoveAllFromCartPayload = {
  __typename?: 'RemoveAllFromCartPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to remove items from the cart. */
  result: CartResult;
};

/** Input for removing an item from the cart. */
export type RemoveCartItemInput = {
  /** CartItem ID */
  cartItemId: Scalars['ID'];
};

/** Autogenerated input type of RemoveFavoriteConsumerOrder */
export type RemoveFavoriteConsumerOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Favorite consumer order ID. */
  favoriteConsumerOrderId: Scalars['ID'];
};

/** Autogenerated return type of RemoveFavoriteConsumerOrder */
export type RemoveFavoriteConsumerOrderPayload = {
  __typename?: 'RemoveFavoriteConsumerOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to remove the favorite. */
  result: FavoriteConsumerOrderResult;
};

/** Autogenerated input type of RemoveItemsFromCart */
export type RemoveItemsFromCartInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Opaque token identifying a specific version of the cart. */
  fingerprint: Scalars['String'];
  /** Input describing which items to remove. */
  removals: Array<RemoveCartItemInput>;
};

/** Autogenerated return type of RemoveItemsFromCart */
export type RemoveItemsFromCartPayload = {
  __typename?: 'RemoveItemsFromCartPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to remove items from the cart. */
  result: CartResult;
};

/** Autogenerated input type of RemoveReward */
export type RemoveRewardInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Opaque token identifying a specific version of the cart. */
  fingerprint: Scalars['String'];
};

/** Autogenerated return type of RemoveReward */
export type RemoveRewardPayload = {
  __typename?: 'RemoveRewardPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to remove reward. */
  result: CartResult;
};

/** Autogenerated input type of ReportPhoneNumberVerification */
export type ReportPhoneNumberVerificationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Phone number in E.164 format, but without the "+" prefix. E.g. "15551231234". */
  phoneNumber: Scalars['String'];
  /** Phone verification code. */
  phoneVerificationCode: Scalars['String'];
};

/** Autogenerated return type of ReportPhoneNumberVerification */
export type ReportPhoneNumberVerificationPayload = {
  __typename?: 'ReportPhoneNumberVerificationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to report phone number verification. */
  result: ReportPhoneNumberVerificationResult;
};

/** Result of attempting to report phone number verification. */
export type ReportPhoneNumberVerificationResult = ErrorsResult | PhoneNumberVerified;

/** Reward. */
export type Reward = Node & {
  __typename?: 'Reward';
  /** Whether reward should be applied automatically upon visiting checkout. */
  autoApply: Scalars['Boolean'];
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID'];
  /** Scope the reward applies to. */
  scope: RewardScope;
  /** Title. */
  title: Scalars['String'];
};

/** Error indicating a reward could not be claimed because the user has already claimed it. */
export type RewardAlreadyClaimed = Error & {
  __typename?: 'RewardAlreadyClaimed';
  /** A description of the error. */
  message: Scalars['String'];
};

/** Error indicating a reward could not be applied because the user has already used it. */
export type RewardAlreadyUsed = Error & {
  __typename?: 'RewardAlreadyUsed';
  /** A description of the error. */
  message: Scalars['String'];
};

/** Error indicating that no reward was found with the provided reward code. */
export type RewardCodeNotFound = Error & {
  __typename?: 'RewardCodeNotFound';
  /** A description of the error. */
  message: Scalars['String'];
};

/** Error indicating the a reward is not applicable. */
export type RewardNotApplicable = Error & {
  __typename?: 'RewardNotApplicable';
  /** A description of the error. */
  message: Scalars['String'];
};

/** Reward mutation result. */
export type RewardResult = ErrorsResult | RewardSuccess;

/** The possible reward scopes. */
export enum RewardScope {
  /** Reward can be applied to the entire cart. */
  Cart = 'cart',
  /** Reward can be applied to a single item. */
  Item = 'item',
  /** Reward, when claimed, increases wallet balance. */
  Wallet = 'wallet'
}

/** Result of a successful reward mutation. */
export type RewardSuccess = {
  __typename?: 'RewardSuccess';
  /** Reward. */
  reward: Reward;
};

export type Route = {
  __typename?: 'Route';
  color?: Maybe<Scalars['String']>;
  /** the driver associated with this route */
  driver?: Maybe<Driver>;
  id: Scalars['ID'];
  /** Boolean to indicate whether this is a lobby route. True indicates a lobby route. */
  isLobby: Scalars['Boolean'];
  /** Delivery route name */
  name: Scalars['String'];
  nightEnd: Scalars['ISO8601Date'];
  /** Delivery route stops, a stop denotes the action of either picking up item(s) or delivering items. */
  stops?: Maybe<Array<DeliveryStop>>;
};

/** Autogenerated input type of RouteDetailsUpdate */
export type RouteDetailsUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Delivery route id. */
  deliveryRouteId: Scalars['ID'];
  /** Driver name. */
  driverName?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of RouteDetailsUpdate */
export type RouteDetailsUpdatePayload = {
  __typename?: 'RouteDetailsUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  route?: Maybe<Route>;
  userErrors: Array<RouteError>;
};

/** Route possible error types */
export type RouteError = InvalidNightEnd | WarehouseNotFound;

export type RouteInput = {
  id: Scalars['ID'];
};

export type RoutesInput = {
  nightEnd?: InputMaybe<Scalars['ISO8601Date']>;
  warehouseId: Scalars['ID'];
};

/** Error indicating that a mutation failed because the requested pickup time is too far in the future. */
export type ScheduledTooFarOut = Error & {
  __typename?: 'ScheduledTooFarOut';
  /** A description of the error. */
  message: Scalars['String'];
};

export type ServiceError = BusinessError & {
  __typename?: 'ServiceError';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type ServiceTask = {
  fulfilledAt?: Maybe<Scalars['ISO8601DateTime']>;
  fulfillmentIssues: Array<FulfillmentIssue>;
  id: Scalars['ID'];
  serviceTaskMessage?: Maybe<ServiceTaskMessage>;
  taskType: Task;
};

export type ServiceTaskGroup = {
  __typename?: 'ServiceTaskGroup';
  cafeActionType: CafeAction;
  id: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  serviceTasks: Array<ServiceTask>;
};

export type ServiceTaskMessage = {
  __typename?: 'ServiceTaskMessage';
  id: Scalars['ID'];
  message: Scalars['String'];
};

export type ServiceTaskOrder = {
  __typename?: 'ServiceTaskOrder';
  id: Scalars['ID'];
  isRecordedInNetsuite: Scalars['Boolean'];
  note?: Maybe<Scalars['String']>;
  order: Order;
  pickedUpAt?: Maybe<Scalars['ISO8601DateTime']>;
  vendorTask?: Maybe<VendorTask>;
};

/** Autogenerated input type of SetServiceTaskGroupNoteMutation */
export type SetServiceTaskGroupNoteMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  note: Scalars['String'];
  serviceTaskGroupId: Scalars['ID'];
};

/** Autogenerated return type of SetServiceTaskGroupNoteMutation */
export type SetServiceTaskGroupNoteMutationPayload = {
  __typename?: 'SetServiceTaskGroupNoteMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<UserError>;
};

/** Autogenerated input type of SetTip */
export type SetTipInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Opaque token identifying a specific version of the cart. */
  fingerprint: Scalars['String'];
  /** Tip expressed as a percent of subtotal. */
  tipPercent?: InputMaybe<Scalars['Int']>;
  /** Tip expressed as a fixed value. */
  tipValue?: InputMaybe<MoneyInput>;
};

/** Autogenerated return type of SetTip */
export type SetTipPayload = {
  __typename?: 'SetTipPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to set tip. */
  result: CartResult;
};

export type Sku = {
  __typename?: 'Sku';
  displayName: Scalars['String'];
  id: Scalars['ID'];
  refrigerationRequired: Scalars['Boolean'];
  refrigerationState: Scalars['String'];
  skuCategory?: Maybe<SkuCategory>;
};

export type SkuCategory = {
  __typename?: 'SkuCategory';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

/** Sort direction values. */
export enum SortDirection {
  /** Ascending, nulls last. */
  Asc = 'ASC',
  /** Descending, nulls first. */
  Desc = 'DESC'
}

/** Error indicating a cart fingerprint mismatch. */
export type StaleCartError = Error & {
  __typename?: 'StaleCartError';
  /** Current cart info. */
  currentCart: Cart;
  /** A description of the error. */
  message: Scalars['String'];
};

/** Error indicating a config edition mismatch */
export type StaleConfigError = {
  __typename?: 'StaleConfigError';
  /** Current config info */
  currentConfig: Config;
  /** A description of the error */
  message: Scalars['String'];
};

/** Error indicating a request was made using outdated refund info. */
export type StaleConsumerRefundInfoError = Error & {
  __typename?: 'StaleConsumerRefundInfoError';
  /** A description of the error. */
  message: Scalars['String'];
};

/** Error indicating an object lock version mismatch. */
export type StaleObjectError = Error & {
  __typename?: 'StaleObjectError';
  /** Object ID. */
  id: Scalars['ID'];
  /** A description of the error. */
  message: Scalars['String'];
};

export enum StandingOrderBehavior {
  Available = 'AVAILABLE',
  NotAvailable = 'NOT_AVAILABLE'
}

/** Autogenerated input type of StartPhoneNumberVerification */
export type StartPhoneNumberVerificationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Phone number in E.164 format, but without the "+" prefix. E.g. "15551231234". */
  phoneNumber: Scalars['String'];
  /** Phone verification application key. */
  phoneVerificationKey?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of StartPhoneNumberVerification */
export type StartPhoneNumberVerificationPayload = {
  __typename?: 'StartPhoneNumberVerificationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to start phone number verification. */
  result: StartPhoneNumberVerificationResult;
};

/** Result of attempting to start phone number verification. */
export type StartPhoneNumberVerificationResult = ErrorsResult | PhoneNumberVerificationStarted;

export type StopInput = {
  id: Scalars['ID'];
};

/** Submenu. */
export type Submenu = Node & {
  __typename?: 'Submenu';
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID'];
  /** Submenu's current lock version, providing concurrency control and protection against stale updates. */
  lockVersion: Scalars['Int'];
  /** Menu items. */
  menuItems: Array<MenuItem>;
  /** Name. */
  name: Scalars['String'];
  /**
   * Hours the submenu is available, in merchant's time zone. Order pickup times
   * cannot be outside the bounds described by these hours when ordering from this submenu.
   */
  operatingHours: Array<OperatingHoursForDayOfWeek>;
  /** The order of the submenu in the UI. */
  sortOrder: Scalars['Int'];
  /** Visibility. */
  visibility: Visibility;
};

/** Submenu mutation result. */
export type SubmenuResult = ErrorsResult | SubmenuSuccess;

/** Result of a successful submenu mutation. */
export type SubmenuSuccess = {
  __typename?: 'SubmenuSuccess';
  /** Resulting submenu. */
  submenu: Submenu;
};

/** Result of mutating a list of submenus. */
export type SubmenusResult = ErrorsResult | SubmenusSuccess;

/** Result of successfully mutating a list of submenus. */
export type SubmenusSuccess = {
  __typename?: 'SubmenusSuccess';
  /** Resulting submenus. */
  submenus: Array<Submenu>;
};

/**
 * An interface is used to represent items to mandate what fields are needed for
 * items. Having a single object with all fields was rejected because that would
 * remove the ability to ensure a type of item has all of its required fields.
 */
export type SupplyItem = {
  brandName: Scalars['String'];
  /** (Package Height x Package Width x Package Length)/DIM factor */
  caseDimensionalWeightLbs?: Maybe<Scalars['Float']>;
  caseHeightInches?: Maybe<Scalars['Float']>;
  caseLengthInches?: Maybe<Scalars['Float']>;
  caseVolumeCuInches?: Maybe<Scalars['Float']>;
  caseWeightLbs?: Maybe<Scalars['Float']>;
  caseWidthInches?: Maybe<Scalars['Float']>;
  catalogStatus: CatalogStatus;
  category: Category;
  createdAt: Scalars['ISO8601DateTime'];
  createdBy: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  /**
   * Drives pricing with carriers like FedEx.
   * This data is uploaded from Cubiscan dimensioning device to optimize shipping costs.
   */
  dimensionalFactor?: Maybe<Scalars['Float']>;
  /** (Package Height x Package Width x Package Length)/DIM factor */
  eachDimensionalWeightLbs?: Maybe<Scalars['Float']>;
  eachHeightInches?: Maybe<Scalars['Float']>;
  eachLengthInches?: Maybe<Scalars['Float']>;
  eachVolumeCuInches?: Maybe<Scalars['Float']>;
  eachWeightLbs?: Maybe<Scalars['Float']>;
  eachWidthInches?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  imgUrl?: Maybe<Scalars['String']>;
  itemSize?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  purchasePrice: Money;
  refrigerationState?: Maybe<RefrigerationState>;
  saleUnit: Unit;
  sampleUnit?: Maybe<Unit>;
  standingOrderBehavior: StandingOrderBehavior;
  subcategory?: Maybe<Category>;
  transitMethod?: Maybe<TransitMethod>;
  updatedAt: Scalars['ISO8601DateTime'];
  updatedBy: Scalars['String'];
  vendorCode?: Maybe<Scalars['String']>;
};

export enum Task {
  /** picking up organic compound waste */
  Compost = 'compost',
  /** picking up leftover pastries for donation */
  Donation = 'donation',
  /** shuffling bins between cafes + HQs */
  InternalLoop = 'internal_loop',
  /** delivering ordered goods */
  OrderFulfillment = 'order_fulfillment'
}

/** Error indicating that tip cannot be set because merchant has not enabled tips. */
export type TipsNotEnabled = Error & {
  __typename?: 'TipsNotEnabled';
  /** A description of the error. */
  message: Scalars['String'];
};

/** Autogenerated input type of ToggleExitDoneMutation */
export type ToggleExitDoneMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  driverVisitId: Scalars['ID'];
  exited: Scalars['Boolean'];
};

/** Autogenerated return type of ToggleExitDoneMutation */
export type ToggleExitDoneMutationPayload = {
  __typename?: 'ToggleExitDoneMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<UserError>;
};

/** Autogenerated input type of ToggleServiceTaskDoneMutation */
export type ToggleServiceTaskDoneMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  delivered: Scalars['Boolean'];
  serviceTaskId: Scalars['ID'];
};

/** Autogenerated return type of ToggleServiceTaskDoneMutation */
export type ToggleServiceTaskDoneMutationPayload = {
  __typename?: 'ToggleServiceTaskDoneMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<UserError>;
};

/** Autogenerated input type of TouchDriverVisitMutation */
export type TouchDriverVisitMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  imageOneS3ObjectKey?: InputMaybe<Scalars['String']>;
  imageTwoS3ObjectKey?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of TouchDriverVisitMutation */
export type TouchDriverVisitMutationPayload = {
  __typename?: 'TouchDriverVisitMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<UserError>;
};

/** Error indicating that a mutation failed due to a transient payment processor error. */
export type TransientPaymentProcessorError = Error & {
  __typename?: 'TransientPaymentProcessorError';
  /** A description of the error. */
  message: Scalars['String'];
};

export enum TransitMethod {
  Delivered = 'DELIVERED',
  PickUp = 'PICK_UP'
}

export type UnavailableItemsInterval = AvailabilityInterval & {
  __typename?: 'UnavailableItemsInterval';
  /** Lower bound. */
  lowerBound: Scalars['ISO8601DateTime'];
  /** Unavailable menu items. */
  unavailableMenuItems: Array<MenuItem>;
  /** Upper bound. */
  upperBound: Scalars['ISO8601DateTime'];
};

export type Unit = {
  __typename?: 'Unit';
  baseUnit?: Maybe<Unit>;
  /**
   * Answers the question: how many/much of the base unit is in this unit?
   * Conversion rate for base units should be 1
   * Example: 1 gallon = 8 pints, so a pint could be represented as
   * having a conversion rate of .125 gallons
   */
  conversionRate: Scalars['Float'];
  id: Scalars['ID'];
  name: Scalars['String'];
  unitType: UnitType;
};

export enum UnitSortOrder {
  ConversionRateAsc = 'CONVERSION_RATE_ASC',
  ConversionRateDesc = 'CONVERSION_RATE_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC'
}

export enum UnitType {
  Case = 'CASE'
}

/** Input for updating an existing cart item. */
export type UpdateCartItemInput = {
  /** ID of the CartItem to update. */
  cartItemId: Scalars['ID'];
  /** ID of desired MenuItemSize. */
  menuItemSizeId: Scalars['ID'];
  /**
   * Desired modifiers. This should include any previously added modifiers you wish
   * to keep as well as any modifiers you wish to add. Previously added modifiers
   * that don't appear in this list will be removed.
   */
  modifiers: Array<CartItemModifierInput>;
  /** Note. If omitted, any previously set note will be cleared. */
  note?: InputMaybe<Scalars['String']>;
  /** Desired quantity. */
  quantity: Scalars['Int'];
  /** Expected unit price of MenuItemSize. Item will only be updated if the desired size's price matches the expected price. */
  unitPrice: MoneyInput;
};

/** Data that was provided as mutation input. */
export type UpdateCartItemInputEcho = {
  __typename?: 'UpdateCartItemInputEcho';
  /** ID of the CartItem to update. */
  cartItemId: Scalars['ID'];
  /** ID of desired MenuItemSize. */
  menuItemSizeId: Scalars['ID'];
  /**
   * Desired modifiers. This should include any previously added modifiers you wish
   * to keep as well as any modifiers you wish to add. Previously added modifiers
   * that don't appear in this list will be removed.
   */
  modifiers: Array<CartItemModifierInputEcho>;
  /** Desired quantity. */
  quantity: Scalars['Int'];
  /** Expected unit price of MenuItemSize. Item will only be updated if the desired size's price matches the expected price. */
  unitPrice: Money;
};

/** Autogenerated input type of UpdateCartItems */
export type UpdateCartItemsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Opaque token identifying a specific version of the cart. */
  fingerprint: Scalars['String'];
  /**
   * List of desired updates. This list only needs to include updates for the items
   * it wants to modify. Any cart items not represented in the listed updates will
   * remain unchanged.
   */
  updates: Array<UpdateCartItemInput>;
};

/** Autogenerated return type of UpdateCartItems */
export type UpdateCartItemsPayload = {
  __typename?: 'UpdateCartItemsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to update cart items. */
  result: CartResult;
};

/** Autogenerated input type of UpdateConfig */
export type UpdateConfigInput = {
  /** App config attributes */
  attributes: ConfigAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Current config's edition (update is rejected if this is out of date) */
  currentEdition?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of UpdateConfig */
export type UpdateConfigPayload = {
  __typename?: 'UpdateConfigPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** @deprecated Use the "result" field instead. */
  configResult: ConfigResult;
  /** Updated config's edition */
  currentEdition?: Maybe<Scalars['Int']>;
  /** Result of attempting to update the config */
  result: ConfigResult;
};

/** Autogenerated input type of UpdateCurrentConsumerAppUser */
export type UpdateCurrentConsumerAppUserInput = {
  /** Accepts promotional emails. May be omitted, but if specified, cannot be null. */
  acceptsPromotionalEmails?: InputMaybe<Scalars['Boolean']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Email. May be omitted, but if specified, cannot be null. */
  email?: InputMaybe<Scalars['String']>;
  /** Merchant can contact. May be omitted, but if specified, cannot be null. */
  merchantCanContact?: InputMaybe<Scalars['Boolean']>;
  /** Username. May be omitted, but if specified, cannot be null. */
  username?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateCurrentConsumerAppUser */
export type UpdateCurrentConsumerAppUserPayload = {
  __typename?: 'UpdateCurrentConsumerAppUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to update the consumer app user. */
  result: ConsumerAppUserResult;
};

/** Autogenerated input type of UpdateCurrentConsumerAppUserPhoneNumber */
export type UpdateCurrentConsumerAppUserPhoneNumberInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Phone number in E.164 format, but without the "+" prefix. E.g. "15551231234". */
  phoneNumber: Scalars['String'];
  /** ID received when verifying phone number. */
  phoneVerificationId: Scalars['ID'];
};

/** Autogenerated return type of UpdateCurrentConsumerAppUserPhoneNumber */
export type UpdateCurrentConsumerAppUserPhoneNumberPayload = {
  __typename?: 'UpdateCurrentConsumerAppUserPhoneNumberPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to update the consumer app user's phone number. */
  result: ConsumerAppUserResult;
};

/** Autogenerated input type of UpdateFulfillmentIssueMutation */
export type UpdateFulfillmentIssueMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  fulfillmentIssueId: Scalars['ID'];
  issue?: InputMaybe<FulfillmentIssueIssue>;
  note?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateFulfillmentIssueMutation */
export type UpdateFulfillmentIssueMutationPayload = {
  __typename?: 'UpdateFulfillmentIssueMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<UserError>;
  id: Scalars['ID'];
};

/** Attributes for creating or updating landed-cost and sale-price */
export type UpdateItemPriceInput = {
  /** Item UUID */
  itemOdekoUuid: Scalars['String'];
  newLandedCost?: InputMaybe<MoneyInput>;
  newSalePrice?: InputMaybe<MoneyInput>;
  previousLandedCost?: InputMaybe<MoneyInput>;
  previousSalePrice?: InputMaybe<MoneyInput>;
  /** Warehouse UUID */
  warehouseOdekoUuid: Scalars['String'];
};

/** Autogenerated input type of UpdateItemPrices */
export type UpdateItemPricesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  customPrices?: InputMaybe<Array<UpdateLocationPriceInput>>;
  prices: Array<UpdateItemPriceInput>;
};

/** Autogenerated return type of UpdateItemPrices */
export type UpdateItemPricesPayload = {
  __typename?: 'UpdateItemPricesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  result?: Maybe<ItemPricesResult>;
};

/** Attributes for creating or updating custom-price */
export type UpdateLocationPriceInput = {
  /** Item UUID */
  itemOdekoUuid: Scalars['String'];
  /** Location UUID */
  locationOdekoUuid: Scalars['String'];
  newCustomPrice?: InputMaybe<MoneyInput>;
  previousCustomPrice?: InputMaybe<MoneyInput>;
};

/** Autogenerated input type of UpdateMenuItemSavedVisibility */
export type UpdateMenuItemSavedVisibilityInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /**
   * MenuItem's current lock version. If an outdated lock version is provided, the
   * operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int'];
  /** MenuItem ID. */
  menuItemId: Scalars['ID'];
  /**
   * Visibility value to save. This sets the menu-item's "visibility.savedValue",
   * whichi will determine its "visibility.effectiveValue" as well iff it belongs
   * to a visible submenu that belongs to a visible menu. If either the submenu or
   * its parent menu are hidden, the menu-item is effectively hidden regardless of
   * its saved visibility value.
   */
  value: VisibilityEnum;
};

/** Autogenerated return type of UpdateMenuItemSavedVisibility */
export type UpdateMenuItemSavedVisibilityPayload = {
  __typename?: 'UpdateMenuItemSavedVisibilityPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to update the menu-item's saved visibility value. */
  result: MenuItemResult;
};

/** Input for updating the sort order of a menu-item. */
export type UpdateMenuItemSortOrderInput = {
  /**
   * MenuItem's current lock version. If an outdated lock version is provided, the
   * operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int'];
  /** MenuItem ID */
  menuItemId: Scalars['ID'];
};

/** Autogenerated input type of UpdateMenuItemsSortOrder */
export type UpdateMenuItemsSortOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /**
   * List describing the desired sort order of submenu's menu-items. This list must
   * be exhaustive, i.e. it should contain an element for each menu-item the
   * submenu has. The operation will be rejected if given a non-exhaustive list or
   * a list that contains duplicates. It will also be rejected if any of the list
   * elements identify menu-items that don't belong to the right submenu.
   */
  elements: Array<UpdateMenuItemSortOrderInput>;
  /** The ID of the submenu whose menu-items are being sorted. */
  submenuId: Scalars['ID'];
};

/** Autogenerated return type of UpdateMenuItemsSortOrder */
export type UpdateMenuItemsSortOrderPayload = {
  __typename?: 'UpdateMenuItemsSortOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to update the menu-items' sort order. */
  result: MenuItemsResult;
};

/** Autogenerated input type of UpdateMenuSavedVisibility */
export type UpdateMenuSavedVisibilityInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /**
   * Menu's current lock version. If an outdated lock version is provided, the
   * operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int'];
  /** Menu ID. */
  menuId: Scalars['ID'];
  /**
   * Visibility value to save. This sets the menu's "visibility.savedValue" and has
   * a cascading effect on the "visibility.effectiveValue" of its submenus and
   * their menu-items. I.e. hiding a menu also changes the effective visibility of
   * its submenus and their menu-items, hiding them from consumers regardless of
   * what the individual "visibility.savedValue" fields hold. Their individual
   * saved values are retained, and will become relevant in determining their
   * effective visibility if the menu is later unhidden.
   */
  value: VisibilityEnum;
};

/** Autogenerated return type of UpdateMenuSavedVisibility */
export type UpdateMenuSavedVisibilityPayload = {
  __typename?: 'UpdateMenuSavedVisibilityPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to update the menu's saved visibility value. */
  result: MenuResult;
};

/** Input for updating the sort order of a menu. */
export type UpdateMenuSortOrderInput = {
  /**
   * Menu's current lock version. If an outdated lock version is provided, the
   * operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int'];
  /** Menu ID */
  menuId: Scalars['ID'];
};

/** Autogenerated input type of UpdateMenusSortOrder */
export type UpdateMenusSortOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /**
   * List describing the desired sort order of merchant's menus. This list must be
   * exhaustive, i.e. it should contain an element for each menu the merchant has.
   * The operation will be rejected if given a non-exhaustive list or a list that
   * contains duplicates. It will also be rejected if any of the list elements
   * identify menus that don't belong to the right merchant.
   */
  elements: Array<UpdateMenuSortOrderInput>;
  /** The ID of the merchant whose menus are being sorted. */
  merchantId: Scalars['ID'];
};

/** Autogenerated return type of UpdateMenusSortOrder */
export type UpdateMenusSortOrderPayload = {
  __typename?: 'UpdateMenusSortOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to update the menus' sort order. */
  result: MenusResult;
};

/** Autogenerated input type of UpdateMerchantCurbsidePickup */
export type UpdateMerchantCurbsidePickupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Whether curbside pickup is offered. */
  curbsidePickup: Scalars['Boolean'];
  /**
   * Merchant's current lock version. If an outdated lock version is provided, the
   * operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int'];
  /** The ID of the merchant to update. */
  merchantId: Scalars['ID'];
};

/** Autogenerated return type of UpdateMerchantCurbsidePickup */
export type UpdateMerchantCurbsidePickupPayload = {
  __typename?: 'UpdateMerchantCurbsidePickupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to update curbsidePickup. */
  result: MerchantResult;
};

/** Autogenerated input type of UpdateMerchantNotificationSound */
export type UpdateMerchantNotificationSoundInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /**
   * Merchant's current lock version. If an outdated lock version is provided, the
   * operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int'];
  /** The ID of the merchant to update. */
  merchantId: Scalars['ID'];
  /** Audio filename to play on notifications for this merchant */
  notificationSound: Scalars['String'];
};

/** Autogenerated return type of UpdateMerchantNotificationSound */
export type UpdateMerchantNotificationSoundPayload = {
  __typename?: 'UpdateMerchantNotificationSoundPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to update notification sound. */
  result: MerchantResult;
};

/** Autogenerated input type of UpdateMerchantPickupText */
export type UpdateMerchantPickupTextInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /**
   * Merchant's current lock version. If an outdated lock version is provided, the
   * operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int'];
  /** The ID of the merchant to update. */
  merchantId: Scalars['ID'];
  /** Pickup text. */
  pickupText?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateMerchantPickupText */
export type UpdateMerchantPickupTextPayload = {
  __typename?: 'UpdateMerchantPickupTextPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to update pickup text. */
  result: MerchantResult;
};

/** Autogenerated input type of UpdateMerchantStatus */
export type UpdateMerchantStatusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /**
   * Merchant's current lock version. If an outdated lock version is provided, the
   * operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int'];
  /** The ID of the merchant to update. */
  merchantId: Scalars['ID'];
  /** Status to set. */
  status: MerchantStatusEnum;
};

/** Autogenerated return type of UpdateMerchantStatus */
export type UpdateMerchantStatusPayload = {
  __typename?: 'UpdateMerchantStatusPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to update the merchant status. */
  result: MerchantResult;
};

/** Autogenerated input type of UpdateModifierGroupSavedVisibility */
export type UpdateModifierGroupSavedVisibilityInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /**
   * Modifier group's current lock version. If an outdated lock version is
   * provided, the operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int'];
  /** Modifier Group ID. */
  modifierGroupId: Scalars['ID'];
  /**
   * Visibility value to save. This sets the modifier group's
   * "visibility.savedValue" and has a cascading effect on the
   * "visibility.effectiveValue" of the options within the group. I.e. hiding a
   * modifier group also changes the effective visibility of its modifier options,
   * hiding them from consumers regardless of what their individual
   * "visibility.savedValue" fields hold. Their individual saved values are
   * retained, and will become relevant in determining their effective visibility
   * if the group is later unhidden.
   */
  value: VisibilityEnum;
};

/** Autogenerated return type of UpdateModifierGroupSavedVisibility */
export type UpdateModifierGroupSavedVisibilityPayload = {
  __typename?: 'UpdateModifierGroupSavedVisibilityPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to update the modifier group's saved visibility value. */
  result: ModifierGroupResult;
};

/** Input for updating the sort order of a modifier group. */
export type UpdateModifierGroupSortOrderInput = {
  /**
   * ModifierGroup's current lock version. If an outdated lock version is provided,
   * the operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int'];
  /** ModifierGroup ID */
  modifierGroupId: Scalars['ID'];
};

/** Autogenerated input type of UpdateModifierGroupsSortOrder */
export type UpdateModifierGroupsSortOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /**
   * List describing the desired sort order of merchant's modifier groups. This
   * list must be exhaustive, i.e. it should contain an element for each modifier
   * group the merchant has. The operation will be rejected if given a
   * non-exhaustive list or a list that contains duplicates. It will also be
   * rejected if any of the list elements identify modifier groups that don't
   * belong to the right merchant.
   */
  elements: Array<UpdateModifierGroupSortOrderInput>;
  /** The ID of the merchant whose modifier groups are being sorted. */
  merchantId: Scalars['ID'];
};

/** Autogenerated return type of UpdateModifierGroupsSortOrder */
export type UpdateModifierGroupsSortOrderPayload = {
  __typename?: 'UpdateModifierGroupsSortOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to update the modifier groups' sort order. */
  result: ModifierGroupsResult;
};

/** Autogenerated input type of UpdateModifierOptionSavedVisibility */
export type UpdateModifierOptionSavedVisibilityInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /**
   * ModifierOption's current lock version. If an outdated lock version is
   * provided, the operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int'];
  /** ModifierOption ID. */
  modifierOptionId: Scalars['ID'];
  /**
   * Visibility value to save. This sets the modifier option's
   * "visibility.savedValue". It also determines the option's effective visibility
   * if it belongs to a visible modifier group. If it belongs to a hidden modifier
   * group, the option remains effectively hidden regardless of its saved
   * visibility value.
   */
  value: VisibilityEnum;
};

/** Autogenerated return type of UpdateModifierOptionSavedVisibility */
export type UpdateModifierOptionSavedVisibilityPayload = {
  __typename?: 'UpdateModifierOptionSavedVisibilityPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to update the modifier option's saved visibility value. */
  result: ModifierOptionResult;
};

/** Input for updating the sort order of a modifier option. */
export type UpdateModifierOptionSortOrderInput = {
  /**
   * ModifierOption's current lock version. If an outdated lock version is
   * provided, the operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int'];
  /** ModifierOption ID */
  modifierOptionId: Scalars['ID'];
};

/** Autogenerated input type of UpdateModifierOptionsSortOrder */
export type UpdateModifierOptionsSortOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /**
   * List describing the desired sort order of modifier group's options. This list
   * must be exhaustive, i.e. it should contain an element for each option in the
   * group. The operation will be rejected if given a non-exhaustive list. It will
   * also be rejected if any of the list elements identify options that don't
   * belong to the right group.
   */
  elements: Array<UpdateModifierOptionSortOrderInput>;
  /** The ID of the modifier group whose options are being sorted. */
  modifierGroupId: Scalars['ID'];
};

/** Autogenerated return type of UpdateModifierOptionsSortOrder */
export type UpdateModifierOptionsSortOrderPayload = {
  __typename?: 'UpdateModifierOptionsSortOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to update the modifier options' sort order. */
  result: ModifierOptionsResult;
};

/** Autogenerated input type of UpdateServiceTaskOrderMutation */
export type UpdateServiceTaskOrderMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  pickedUp: Scalars['Boolean'];
  serviceTaskOrderId: Scalars['ID'];
};

/** Autogenerated return type of UpdateServiceTaskOrderMutation */
export type UpdateServiceTaskOrderMutationPayload = {
  __typename?: 'UpdateServiceTaskOrderMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<UserError>;
  serviceTaskOrder?: Maybe<ServiceTaskOrder>;
};

/** Autogenerated input type of UpdateSubmenuSavedVisibility */
export type UpdateSubmenuSavedVisibilityInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /**
   * Submenu's current lock version. If an outdated lock version is provided, the
   * operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int'];
  /** Submenu ID. */
  submenuId: Scalars['ID'];
  /**
   * Visibility value to save. This sets the submenu's "visibility.savedValue" and
   * has a cascading effect on the "visibility.effectiveValue" of its menu-items.
   * This also determines the submenu's effective visibility if it belongs to a
   * visible menu. If it belongs to a hidden menu, the submenu remains effectively
   * hidden regardless of its saved visibility value.
   */
  value: VisibilityEnum;
};

/** Autogenerated return type of UpdateSubmenuSavedVisibility */
export type UpdateSubmenuSavedVisibilityPayload = {
  __typename?: 'UpdateSubmenuSavedVisibilityPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to update the submenu's saved visibility value. */
  result: SubmenuResult;
};

/** Input for updating the sort order of a submenu. */
export type UpdateSubmenuSortOrderInput = {
  /**
   * Submenu's current lock version. If an outdated lock version is provided, the
   * operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int'];
  /** Submenu ID */
  submenuId: Scalars['ID'];
};

/** Autogenerated input type of UpdateSubmenusSortOrder */
export type UpdateSubmenusSortOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /**
   * List describing the desired sort order of menu's submenus. This list must be
   * exhaustive, i.e. it should contain an element for each submenu the menu has.
   * The operation will be rejected if given a non-exhaustive list or a list that
   * contains duplicates. It will also be rejected if any of the list elements
   * identify submenus that don't belong to the right menu.
   */
  elements: Array<UpdateSubmenuSortOrderInput>;
  /** The ID of the menu whose submenus are being sorted. */
  menuId: Scalars['ID'];
};

/** Autogenerated return type of UpdateSubmenusSortOrder */
export type UpdateSubmenusSortOrderPayload = {
  __typename?: 'UpdateSubmenusSortOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to update the submenus' sort order. */
  result: SubmenusResult;
};

/** Autogenerated input type of UpdateVendorTaskMutation */
export type UpdateVendorTaskMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  fulfilled: Scalars['Boolean'];
  note?: InputMaybe<Scalars['String']>;
  vendorTaskId: Scalars['ID'];
};

/** Autogenerated return type of UpdateVendorTaskMutation */
export type UpdateVendorTaskMutationPayload = {
  __typename?: 'UpdateVendorTaskMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<UserError>;
  vendorTask?: Maybe<VendorTask>;
};

export type UploadItemImage = {
  __typename?: 'UploadItemImage';
  key: Scalars['String'];
  url: Scalars['String'];
};

export type UploadItemImageByKey = {
  __typename?: 'UploadItemImageByKey';
  url: Scalars['String'];
};

/** Autogenerated input type of UpsertWarehouseZipcodes */
export type UpsertWarehouseZipcodesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  warehouseId: Scalars['ID'];
  zipcodes: Array<Scalars['String']>;
};

/** Autogenerated return type of UpsertWarehouseZipcodes */
export type UpsertWarehouseZipcodesPayload = {
  __typename?: 'UpsertWarehouseZipcodesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<UserError>;
  zipcodes: Array<Zipcode>;
};

/**
 * A user is an individual's account on Odeko that can access services according to
 * their roles and permissions.
 */
export type User = {
  __typename?: 'User';
  availableItemById?: Maybe<SupplyItem>;
  availableItemByName?: Maybe<SupplyItem>;
  availableItemByUpcCode?: Maybe<SupplyItem>;
  /** Extended fields */
  availableItems: ItemConnection;
  /** The user's email. */
  email?: Maybe<Scalars['String']>;
  /** The user's unique identifier. */
  id: Scalars['ID'];
  locations: LocationConnection;
  /** The user's granted permissions. */
  permissions?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The user's assigned roles. */
  roles?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/**
 * A user is an individual's account on Odeko that can access services according to
 * their roles and permissions.
 */
export type UserAvailableItemByIdArgs = {
  id: Scalars['ID'];
};


/**
 * A user is an individual's account on Odeko that can access services according to
 * their roles and permissions.
 */
export type UserAvailableItemByNameArgs = {
  name: Scalars['String'];
};


/**
 * A user is an individual's account on Odeko that can access services according to
 * their roles and permissions.
 */
export type UserAvailableItemByUpcCodeArgs = {
  upcCode: Scalars['String'];
};


/**
 * A user is an individual's account on Odeko that can access services according to
 * their roles and permissions.
 */
export type UserAvailableItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  categories?: InputMaybe<Array<InputMaybe<ItemsCategoryInput>>>;
  first?: InputMaybe<Scalars['Int']>;
  itemTypes?: InputMaybe<Array<InputMaybe<ItemType>>>;
  last?: InputMaybe<Scalars['Int']>;
  searchQuery?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Array<InputMaybe<ItemsSortOrder>>>;
  subcategories?: InputMaybe<Array<InputMaybe<ItemsSubcategoryInput>>>;
  vendors?: InputMaybe<Array<InputMaybe<ItemsVendorInput>>>;
  warehouses?: InputMaybe<Array<InputMaybe<ItemsWarehouseInput>>>;
};


/**
 * A user is an individual's account on Odeko that can access services according to
 * their roles and permissions.
 */
export type UserLocationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** User-readable error */
export type UserError = {
  __typename?: 'UserError';
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type Vendor = {
  __typename?: 'Vendor';
  address?: Maybe<Address>;
  id: Scalars['ID'];
  isWarehouse: Scalars['Boolean'];
  name: Scalars['String'];
  vendorAccessInstruction?: Maybe<VendorAccessInstruction>;
  vendorItemInstruction?: Maybe<VendorItemInstruction>;
};

export type VendorAccessInstruction = {
  __typename?: 'VendorAccessInstruction';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  imageUrls?: Maybe<Array<Scalars['String']>>;
  note?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
  videoUrls?: Maybe<Array<Scalars['String']>>;
};

export type VendorItemInstruction = {
  __typename?: 'VendorItemInstruction';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  imageUrls?: Maybe<Array<Scalars['String']>>;
  note?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
  videoUrls?: Maybe<Array<Scalars['String']>>;
};

export type VendorTask = {
  fulfilledAt?: Maybe<Scalars['ISO8601DateTime']>;
  fulfillmentIssues: Array<FulfillmentIssue>;
  id: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  serviceTaskOrder?: Maybe<ServiceTaskOrder>;
  taskType: CafeAction;
  vendorVisit: VendorVisit;
};

export type VendorTaskList = {
  __typename?: 'VendorTaskList';
  nightEnd: Scalars['ISO8601Date'];
  nightStart: Scalars['ISO8601Date'];
  tasks: Array<VendorTask>;
  vendor: Vendor;
};

export type VendorVisit = {
  __typename?: 'VendorVisit';
  deliveryRoute: DeliveryRoute;
  nightEnd: Scalars['ISO8601Date'];
  nightStart: Scalars['ISO8601Date'];
  serviceTaskOrders: Array<ServiceTaskOrder>;
  vendor: Vendor;
  vendorTasks: Array<VendorTask>;
};

export type Visibility = {
  __typename?: 'Visibility';
  /** Effective value, accounting for saved value and the visibility of parent objects. */
  effectiveValue: VisibilityEnum;
  /**
   * Saved value. This does not account for the visibility of parent objects, which
   * could mask an otherwise visible object. See effectiveValue.
   */
  savedValue: VisibilityEnum;
};

/** The possible visibility values. */
export enum VisibilityEnum {
  /** Hidden. */
  Hidden = 'hidden',
  /** Visible. */
  Visible = 'visible'
}

export enum VisitStatus {
  /** driver visit is touched & has all fulfilled tasks */
  Done = 'done',
  /** driver visit is touched & has at least two unfulfilled tasks or has at least one note */
  Error = 'error',
  /** driver visit is new & untouched */
  New = 'new',
  /** driver visit is touched but has all unfilfilled tasks & no note */
  Viewed = 'viewed'
}

/** Wallet. */
export type Wallet = {
  __typename?: 'Wallet';
  /** Square default card id. */
  squareDefaultCardId?: Maybe<Scalars['String']>;
};

/** Error indicating that a mutation failed because the wallet balance is insufficient. */
export type WalletBalanceInsufficient = Error & {
  __typename?: 'WalletBalanceInsufficient';
  /** A description of the error. */
  message: Scalars['String'];
};

/** Wallet mutation result. */
export type WalletResult = ErrorsResult | WalletSuccess;

/** Error indicating that a mutation failed because the wallet's squareUserId is blank. */
export type WalletSquareUserIdBlank = Error & {
  __typename?: 'WalletSquareUserIdBlank';
  /** A description of the error. */
  message: Scalars['String'];
};

/** Result of a successful wallet mutation. */
export type WalletSuccess = {
  __typename?: 'WalletSuccess';
  /** Resulting wallet. */
  wallet: Wallet;
};

export type Warehouse = {
  __typename?: 'Warehouse';
  categories: Array<Category>;
  currentNightEnd?: Maybe<Scalars['ISO8601DateTime']>;
  deliveryRoutes?: Maybe<Array<DeliveryRoute>>;
  id: Scalars['ID'];
  name: Scalars['String'];
  pkId?: Maybe<Scalars['ID']>;
  timeZone: Scalars['String'];
  vendor?: Maybe<Array<Vendor>>;
  /** Gets tasks for individual vendor associated to warehouse */
  vendorTasks?: Maybe<Array<VendorTaskList>>;
  /** Gets all vendor tasks for a warehouse */
  vendorsTasks?: Maybe<Array<VendorTaskList>>;
  zipcodes?: Maybe<Array<Zipcode>>;
};


export type WarehouseCategoriesArgs = {
  filter?: InputMaybe<CategoriesFilter>;
  sortOrder?: InputMaybe<Array<InputMaybe<CategoriesSortOrder>>>;
};


export type WarehouseDeliveryRoutesArgs = {
  nightEnd?: InputMaybe<Scalars['ISO8601DateTime']>;
};


export type WarehouseVendorTasksArgs = {
  nightEnd?: InputMaybe<Scalars['ISO8601DateTime']>;
  vendorId: Scalars['ID'];
};


export type WarehouseVendorsTasksArgs = {
  nightEnd?: InputMaybe<Scalars['ISO8601DateTime']>;
};


export type WarehouseZipcodesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
};

export type WarehouseNotFound = BusinessError & {
  __typename?: 'WarehouseNotFound';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type Zipcode = {
  __typename?: 'Zipcode';
  active: Scalars['Boolean'];
  id: Scalars['ID'];
  warehouseId?: Maybe<Scalars['ID']>;
  warehouseName?: Maybe<Scalars['String']>;
  zipCode: Scalars['String'];
};

export type PricingGetItemForEditQueryVariables = Exact<{
  itemId: Scalars['ID'];
  warehouseIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type PricingGetItemForEditQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', availableItemById?: { __typename: 'InventoryItem', perishability?: Perishability | null, upcCodes?: Array<string | null> | null, shelfLifeDays?: number | null, locationShelfLifeDays?: number | null, erpRecordUrl?: string | null, id: string, name: string, brandName: string, description?: string | null, catalogStatus: CatalogStatus, imgUrl?: string | null, createdAt: any, updatedAt: any, vendorCode?: string | null, stockUnit?: { __typename?: 'Unit', name: string } | null, purchaseUnit: { __typename?: 'Unit', name: string, conversionRate: number }, warehouseAssociation?: Array<{ __typename?: 'InventoryWarehouseAssociation', warehouse: { __typename?: 'Warehouse', id: string, name: string }, landedCost?: { __typename?: 'Money', cents: number, currency: Currency } | null, salePrice?: { __typename?: 'Money', cents: number, currency: Currency } | null } | null> | null, itemLocationsCustomPrice?: Array<{ __typename?: 'ItemLocationCustomPrice', location?: { __typename?: 'Location', id: string, businessName: string, warehouse: { __typename?: 'Warehouse', id: string, name: string } } | null, customPrice?: { __typename?: 'Money', cents: number, currency: Currency } | null }> | null, category: { __typename?: 'Category', name: string }, subcategory?: { __typename?: 'Category', name: string } | null, purchasePrice: { __typename?: 'Money', cents: number, currency: Currency }, saleUnit: { __typename?: 'Unit', name: string, unitType: UnitType, conversionRate: number } } | { __typename: 'NonInventoryItem', minItemsPerOrder?: number | null, purchaseMultiple: number, erpRecordUrl?: string | null, id: string, name: string, brandName: string, description?: string | null, catalogStatus: CatalogStatus, imgUrl?: string | null, createdAt: any, updatedAt: any, vendorCode?: string | null, warehouseAssociation?: Array<{ __typename?: 'NonInventoryWarehouseAssociation', warehouse: { __typename?: 'Warehouse', id: string, name: string }, landedCost?: { __typename?: 'Money', cents: number, currency: Currency } | null, salePrice?: { __typename?: 'Money', cents: number, currency: Currency } | null } | null> | null, itemLocationsCustomPrice?: Array<{ __typename?: 'ItemLocationCustomPrice', location?: { __typename?: 'Location', id: string, businessName: string, warehouse: { __typename?: 'Warehouse', id: string, name: string } } | null, customPrice?: { __typename?: 'Money', cents: number, currency: Currency } | null }> | null, category: { __typename?: 'Category', name: string }, subcategory?: { __typename?: 'Category', name: string } | null, purchasePrice: { __typename?: 'Money', cents: number, currency: Currency }, saleUnit: { __typename?: 'Unit', name: string, unitType: UnitType, conversionRate: number } } | null } | null };

export type PricingGetLocationsFromSearchQueryVariables = Exact<{
  first: Scalars['Int'];
  name: Scalars['String'];
}>;


export type PricingGetLocationsFromSearchQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', locations: { __typename?: 'LocationConnection', nodes?: Array<{ __typename?: 'Location', id: string, businessName: string, warehouse: { __typename?: 'Warehouse', id: string, name: string } } | null> | null } } | null };

export type PricingGetWarehousesQueryVariables = Exact<{ [key: string]: never; }>;


export type PricingGetWarehousesQuery = { __typename?: 'Query', warehouses: Array<{ __typename?: 'Warehouse', id: string, name: string }> };

export type PricingUpdateItemPricesMutationVariables = Exact<{
  input: UpdateItemPricesInput;
}>;


export type PricingUpdateItemPricesMutation = { __typename?: 'Mutation', updateItemPrices: { __typename?: 'UpdateItemPricesPayload', result?: { __typename: 'ErrorsResult', errors: { __typename?: 'Errors', head: { __typename?: 'AmbiguousCartItemUpdates', message: string } | { __typename?: 'BadPaymentProcessorRequestError', message: string } | { __typename?: 'CartCheckoutInFlightError', message: string } | { __typename?: 'CartItemModifierGroupNotFound', message: string } | { __typename?: 'CartItemModifierOptionNotFound', message: string } | { __typename?: 'CartItemNotAdded', message: string } | { __typename?: 'CartItemNotAvailable', message: string } | { __typename?: 'CartItemNotUpdated', message: string } | { __typename?: 'CartItemSizeNotFound', message: string } | { __typename?: 'CartMenuItemNotFound', message: string } | { __typename?: 'CartMerchantMismatchError', message: string } | { __typename?: 'CartNotSaved', message: string } | { __typename?: 'CartPickupUnavailableError', message: string } | { __typename?: 'ConsumerAppUserInvalid', message: string } | { __typename?: 'ConsumerAppUserNotSaved', message: string } | { __typename?: 'ConsumerOrderAlreadyRefunded', message: string } | { __typename?: 'CurbsidePickupNotEnabled', message: string } | { __typename?: 'DuplicateInputError', message: string } | { __typename?: 'EmailAlreadyTaken', message: string } | { __typename?: 'EmptyCartError', message: string } | { __typename?: 'ErrorUpdatingItemPrices', message: string } | { __typename?: 'InvalidCartInputError', message: string } | { __typename?: 'MerchantClosureError', message: string } | { __typename?: 'MerchantNotActive', message: string } | { __typename?: 'ModifierBoundsViolation', message: string } | { __typename?: 'MustRecalculateCartPrices', message: string } | { __typename?: 'NotEnoughNotice', message: string } | { __typename?: 'NothingToRefund', message: string } | { __typename?: 'ObjectFromOutsideCollection', message: string } | { __typename?: 'ObjectNotFound', message: string } | { __typename?: 'ObjectNotSaved', message: string } | { __typename?: 'ObjectOmittedFromCollection', message: string } | { __typename?: 'OrderNotFree', message: string } | { __typename?: 'PaymentProcessorGenericError', message: string } | { __typename?: 'PhoneNumberAlreadyTaken', message: string } | { __typename?: 'PhoneNumberNotFormatted', message: string } | { __typename?: 'PhoneNumberNotVerified', message: string } | { __typename?: 'PhoneNumberVerificationNotStarted', message: string } | { __typename?: 'PriceCorrection', message: string } | { __typename?: 'RefundingTooManyItems', message: string } | { __typename?: 'RefundingTooManyModifiers', message: string } | { __typename?: 'RewardAlreadyClaimed', message: string } | { __typename?: 'RewardAlreadyUsed', message: string } | { __typename?: 'RewardCodeNotFound', message: string } | { __typename?: 'RewardNotApplicable', message: string } | { __typename?: 'ScheduledTooFarOut', message: string } | { __typename?: 'StaleCartError', message: string } | { __typename?: 'StaleConsumerRefundInfoError', message: string } | { __typename?: 'StaleObjectError', message: string } | { __typename?: 'TipsNotEnabled', message: string } | { __typename?: 'TransientPaymentProcessorError', message: string } | { __typename?: 'WalletBalanceInsufficient', message: string } | { __typename?: 'WalletSquareUserIdBlank', message: string }, tail: Array<{ __typename?: 'AmbiguousCartItemUpdates', message: string } | { __typename?: 'BadPaymentProcessorRequestError', message: string } | { __typename?: 'CartCheckoutInFlightError', message: string } | { __typename?: 'CartItemModifierGroupNotFound', message: string } | { __typename?: 'CartItemModifierOptionNotFound', message: string } | { __typename?: 'CartItemNotAdded', message: string } | { __typename?: 'CartItemNotAvailable', message: string } | { __typename?: 'CartItemNotUpdated', message: string } | { __typename?: 'CartItemSizeNotFound', message: string } | { __typename?: 'CartMenuItemNotFound', message: string } | { __typename?: 'CartMerchantMismatchError', message: string } | { __typename?: 'CartNotSaved', message: string } | { __typename?: 'CartPickupUnavailableError', message: string } | { __typename?: 'ConsumerAppUserInvalid', message: string } | { __typename?: 'ConsumerAppUserNotSaved', message: string } | { __typename?: 'ConsumerOrderAlreadyRefunded', message: string } | { __typename?: 'CurbsidePickupNotEnabled', message: string } | { __typename?: 'DuplicateInputError', message: string } | { __typename?: 'EmailAlreadyTaken', message: string } | { __typename?: 'EmptyCartError', message: string } | { __typename?: 'ErrorUpdatingItemPrices', message: string } | { __typename?: 'InvalidCartInputError', message: string } | { __typename?: 'MerchantClosureError', message: string } | { __typename?: 'MerchantNotActive', message: string } | { __typename?: 'ModifierBoundsViolation', message: string } | { __typename?: 'MustRecalculateCartPrices', message: string } | { __typename?: 'NotEnoughNotice', message: string } | { __typename?: 'NothingToRefund', message: string } | { __typename?: 'ObjectFromOutsideCollection', message: string } | { __typename?: 'ObjectNotFound', message: string } | { __typename?: 'ObjectNotSaved', message: string } | { __typename?: 'ObjectOmittedFromCollection', message: string } | { __typename?: 'OrderNotFree', message: string } | { __typename?: 'PaymentProcessorGenericError', message: string } | { __typename?: 'PhoneNumberAlreadyTaken', message: string } | { __typename?: 'PhoneNumberNotFormatted', message: string } | { __typename?: 'PhoneNumberNotVerified', message: string } | { __typename?: 'PhoneNumberVerificationNotStarted', message: string } | { __typename?: 'PriceCorrection', message: string } | { __typename?: 'RefundingTooManyItems', message: string } | { __typename?: 'RefundingTooManyModifiers', message: string } | { __typename?: 'RewardAlreadyClaimed', message: string } | { __typename?: 'RewardAlreadyUsed', message: string } | { __typename?: 'RewardCodeNotFound', message: string } | { __typename?: 'RewardNotApplicable', message: string } | { __typename?: 'ScheduledTooFarOut', message: string } | { __typename?: 'StaleCartError', message: string } | { __typename?: 'StaleConsumerRefundInfoError', message: string } | { __typename?: 'StaleObjectError', message: string } | { __typename?: 'TipsNotEnabled', message: string } | { __typename?: 'TransientPaymentProcessorError', message: string } | { __typename?: 'WalletBalanceInsufficient', message: string } | { __typename?: 'WalletSquareUserIdBlank', message: string }> } } | { __typename: 'ItemPricesSuccess', updatedItemsCount: number, updatedWarehouseItemsCount: number } | null } };


export const PricingGetItemForEditDocument = gql`
    query pricingGetItemForEdit($itemId: ID!, $warehouseIds: [ID!]) {
  viewer {
    availableItemById(id: $itemId) {
      __typename
      id
      name
      brandName
      description
      catalogStatus
      imgUrl
      createdAt
      updatedAt
      vendorCode
      category {
        name
      }
      subcategory {
        name
      }
      ... on InventoryItem {
        __typename
        perishability
        upcCodes
        shelfLifeDays
        locationShelfLifeDays
        stockUnit {
          name
        }
        purchaseUnit {
          name
          conversionRate
        }
        warehouseAssociation(warehouseIds: $warehouseIds) {
          warehouse {
            id
            name
          }
          landedCost {
            cents
            currency
          }
          salePrice {
            cents
            currency
          }
        }
        erpRecordUrl
        itemLocationsCustomPrice {
          location {
            id
            businessName
            warehouse {
              id
              name
            }
          }
          customPrice {
            cents
            currency
          }
        }
      }
      ... on NonInventoryItem {
        __typename
        minItemsPerOrder
        purchaseMultiple
        warehouseAssociation(warehouseIds: $warehouseIds) {
          warehouse {
            id
            name
          }
          landedCost {
            cents
            currency
          }
          salePrice {
            cents
            currency
          }
        }
        erpRecordUrl
        itemLocationsCustomPrice {
          location {
            id
            businessName
            warehouse {
              id
              name
            }
          }
          customPrice {
            cents
            currency
          }
        }
      }
      purchasePrice {
        cents
        currency
      }
      saleUnit {
        name
        unitType
        conversionRate
      }
    }
  }
}
    `;

export function usePricingGetItemForEditQuery(options: Omit<Urql.UseQueryArgs<PricingGetItemForEditQueryVariables>, 'query'>) {
  return Urql.useQuery<PricingGetItemForEditQuery>({ query: PricingGetItemForEditDocument, ...options });
};
export const PricingGetLocationsFromSearchDocument = gql`
    query pricingGetLocationsFromSearch($first: Int!, $name: String!) {
  viewer {
    locations(first: $first, name: $name) {
      nodes {
        id
        businessName
        warehouse {
          id
          name
        }
      }
    }
  }
}
    `;

export function usePricingGetLocationsFromSearchQuery(options: Omit<Urql.UseQueryArgs<PricingGetLocationsFromSearchQueryVariables>, 'query'>) {
  return Urql.useQuery<PricingGetLocationsFromSearchQuery>({ query: PricingGetLocationsFromSearchDocument, ...options });
};
export const PricingGetWarehousesDocument = gql`
    query pricingGetWarehouses {
  warehouses {
    id
    name
  }
}
    `;

export function usePricingGetWarehousesQuery(options?: Omit<Urql.UseQueryArgs<PricingGetWarehousesQueryVariables>, 'query'>) {
  return Urql.useQuery<PricingGetWarehousesQuery>({ query: PricingGetWarehousesDocument, ...options });
};
export const PricingUpdateItemPricesDocument = gql`
    mutation pricingUpdateItemPrices($input: UpdateItemPricesInput!) {
  updateItemPrices(input: $input) {
    result {
      __typename
      ... on ItemPricesSuccess {
        updatedItemsCount
        updatedWarehouseItemsCount
      }
      ... on ErrorsResult {
        errors {
          head {
            message
          }
          tail {
            message
          }
        }
      }
    }
  }
}
    `;

export function usePricingUpdateItemPricesMutation() {
  return Urql.useMutation<PricingUpdateItemPricesMutation, PricingUpdateItemPricesMutationVariables>(PricingUpdateItemPricesDocument);
};